import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`All notable changes to this project will be documented in this file.
See `}<a parentName="p" {...{
        "href": "https://conventionalcommits.org"
      }}>{`Conventional Commits`}</a>{` for commit guidelines.`}</p>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.15.1...@kiwicom/orbit-components@2.16.0"
      }}>{`2.16.0`}</a>{` (2022-03-11)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ItinerarySegmentDetail:`}</strong>{` expandable, only if content is provided (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3303"
        }}>{`#3303`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d840627294a5744838da2adb3beed4f5e50c2a3c"
        }}>{`d840627`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Illustrations:`}</strong>{` add new Chatbot, FareLock illustrations (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3304"
        }}>{`#3304`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/31d5d82e77e33204fcc2fc817af03afebc1a4e1b"
        }}>{`31d5d82`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.15.0...@kiwicom/orbit-components@2.15.1"
      }}>{`2.15.1`}</a>{` (2022-03-07)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Tile:`}</strong>{` fix tile anchor (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3302"
        }}>{`#3302`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/68c0bfae3391fd22d70bef9d4b384dc638c2e049"
        }}>{`68c0bfa`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.14.2...@kiwicom/orbit-components@2.15.0"
      }}>{`2.15.0`}</a>{` (2022-03-02)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputGroup:`}</strong>{` pass and test forwardRef (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c1ef41729822bacd07adafd2004cf3c9bbf727a1"
        }}>{`c1ef417`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ItinerarySegmentDetail:`}</strong>{` fix click event for badges (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/99305aef6344908fa5b6f2e27c4ccc8ceb4e95b8"
        }}>{`99305ae`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`List:`}</strong>{` remove additional spacing (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3299"
        }}>{`#3299`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/be2ac7c6b80d1aa079b22cf19f38b20a97cc8f48"
        }}>{`be2ac7c`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`HorizontalScroll:`}</strong>{` add onOverflow prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ec04d319484a0d92bf7e1b486a5d6547c66bf533"
        }}>{`ec04d31`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.14.1...@kiwicom/orbit-components@2.14.2"
      }}>{`2.14.2`}</a>{` (2022-02-28)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Alert:`}</strong>{` fix content line-height (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/485b67f54661da9e201201eece014bb24a6fe3fd"
        }}>{`485b67f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ChoiceGroup:`}</strong>{` add forwardRef (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3158068029efb48263fb1c3ed5bc5ae843a1b31a"
        }}>{`3158068`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Drawer:`}</strong>{` autofocus close button when opened (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/39dc39c2cbf80ff978ef1e353ea703ee076d7b7e"
        }}>{`39dc39c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Drawer:`}</strong>{` close on ESC (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0de54eea5c72e2847f1a9a455ad037dae4c0e9ee"
        }}>{`0de54ee`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Drawer:`}</strong>{` use focus trap (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8291bd3539905c97f407d72c02950e0a75850524"
        }}>{`8291bd3`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputGroup:`}</strong>{` add forwardRef (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/78ff5f76ac93a98f65f8db53e24d0d025280496e"
        }}>{`78ff5f7`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.14.0...@kiwicom/orbit-components@2.14.1"
      }}>{`2.14.1`}</a>{` (2022-02-21)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Popover:`}</strong>{` remove animation on desktop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1b5d613a4ae3a634a13ac019776d0b520cf6c04b"
        }}>{`1b5d613`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.13.0...@kiwicom/orbit-components@2.14.0"
      }}>{`2.14.0`}</a>{` (2022-02-21)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Card:`}</strong>{` change chevron icon color to secondary (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/813c02fb04ab2d7e6252bcb469479909de8a40ce"
        }}>{`813c02f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Collapse:`}</strong>{` change icon color to secondary (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ccc945befffa0663717aee14009f8d2c72e043fc"
        }}>{`ccc945b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Drawer:`}</strong>{` new z-index value (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/df4a5715fcb55e1a86eeeed3ca8960c53a760831"
        }}>{`df4a571`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Drawer:`}</strong>{` use new z-index value (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3292"
        }}>{`#3292`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b0c5a6da773c74060842b299ec5b1a2518d091f6"
        }}>{`b0c5a6d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ItinerarySegmentDetail:`}</strong>{` change chevron to secondary color (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8b05f165730c98495f3351a8435f42e08a48d47b"
        }}>{`8b05f16`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Select:`}</strong>{` change icon color to InkLight (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4467e539ba2f047b3db6acd81403f73600d71255"
        }}>{`4467e53`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tag:`}</strong>{` fix persistant focus (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3287"
        }}>{`#3287`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/286088ed81f25200d3aab94e103ec5b5d5dbde42"
        }}>{`286088e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tile:`}</strong>{` change chevon icon color to secondary (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/68cb181c31a5b390e2841e8163c955a2178697bc"
        }}>{`68cb181`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useScrollLock:`}</strong>{` return reserveScrollBarGap option (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3286"
        }}>{`#3286`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/118a9cb0956bda40625d5bb7f8cbe34609728d69"
        }}>{`118a9cb`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`NavigationBar:`}</strong>{` add hideOnScroll prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3282"
        }}>{`#3282`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c253f23b46040af1917f71527037019e6a57c7a8"
        }}>{`c253f23`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.12.0...@kiwicom/orbit-components@2.13.0"
      }}>{`2.13.0`}</a>{` (2022-02-10)`}</h2>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Alert:`}</strong>{` visual alert component updates (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3277"
        }}>{`#3277`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b68b4a23c02707e8307547962b13eaf777191cfd"
        }}>{`b68b4a2`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.11.0...@kiwicom/orbit-components@2.12.0"
      }}>{`2.12.0`}</a>{` (2022-02-09)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` enable tooltip on hover when disabled (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3274"
        }}>{`#3274`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/cb61420c5e826a8bdda86d9c661cf73cfe49d7a6"
        }}>{`cb61420`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Itinerary:`}</strong>{` fix overflowing badges (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3275"
        }}>{`#3275`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e894fcef7b5dae6ea2015ed15997b6361ecd7a6e"
        }}>{`e894fce`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Drawer:`}</strong>{` add fixedHeader prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3269"
        }}>{`#3269`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a6658a454614adbf0e65affceb6988c2aea66799"
        }}>{`a6658a4`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.10.0...@kiwicom/orbit-components@2.11.0"
      }}>{`2.11.0`}</a>{` (2022-02-07)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ItinerarySegmentDetail:`}</strong>{` fix overflowing badges (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5a4bea77bda557d666fd42bbd54640300fba67f8"
        }}>{`5a4bea7`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Badge:`}</strong>{` add new bundle type (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1c92c6276bd4871f794724e5e2eb1011dc085feb"
        }}>{`1c92c62`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Button:`}</strong>{` add new bundle type (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ad7c435ecfdf17e0cac3db3985b06e4bb07da56b"
        }}>{`ad7c435`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`HorizontalScroll:`}</strong>{` add elevationOverflow and elevationColor props (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8c7ce02a7ec5436cdc069bb3d0f4d3e4c5ea36bf"
        }}>{`8c7ce02`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.9.0...@kiwicom/orbit-components@2.10.0"
      }}>{`2.10.0`}</a>{` (2022-02-02)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputGroup:`}</strong>{` fix issue with long labels (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3256"
        }}>{`#3256`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9690e1ec7b379d90cbc0688c91f12c5209c330d6"
        }}>{`9690e1e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useTransition:`}</strong>{` replace `}<inlineCode parentName="li">{`enter`}</inlineCode>{` API with `}<inlineCode parentName="li">{`state`}</inlineCode>{` (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ab239d44dd7dbb0e5ede7791f6a6fc97dfddc47d"
        }}>{`ab239d4`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`add new experimental hook `}<inlineCode parentName="li">{`useTransition`}</inlineCode>{` (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3191"
        }}>{`#3191`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3758af591f0b8b63b722e93571276485ec0ea010"
        }}>{`3758af5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`icons:`}</strong>{` add new flash icon (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3260"
        }}>{`#3260`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/574299ee5a59d18f6635e29727d496b44c17131c"
        }}>{`574299e`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.8.1...@kiwicom/orbit-components@2.9.0"
      }}>{`2.9.0`}</a>{` (2022-01-24)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ButtonPrimitive:`}</strong>{` preserve `}<inlineCode parentName="li">{`:hover`}</inlineCode>{` and `}<inlineCode parentName="li">{`:active`}</inlineCode>{` styles (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6b67b24ac1c6406d86f289a12f8e475d0ca2bcaa"
        }}>{`6b67b24`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ErrorFormTooltip:`}</strong>{` help closable onBlur (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3246"
        }}>{`#3246`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9a0c04df8a1947448ba58d91c7f9d261516b7031"
        }}>{`9a0c04d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Itinerary:`}</strong>{` truncate possible long texts (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3247"
        }}>{`#3247`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/740c798773e8761cdc3fdfa858d4f8afae162a12"
        }}>{`740c798`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Popover:`}</strong>{` ensure rounded bottom corners when `}<inlineCode parentName="li">{`actions`}</inlineCode>{` are defined (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f8f6e3982e1a5d5fb178398b1f9c6366589fedb6"
        }}>{`f8f6e39`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Separator:`}</strong>{` add props `}<inlineCode parentName="li">{`indent`}</inlineCode>{` and `}<inlineCode parentName="li">{`align`}</inlineCode>{` (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e8f5bcb067b05208c44981cc9bc113cf269daec3"
        }}>{`e8f5bcb`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SocialButton:`}</strong>{` add chevron icons (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/538a28a5806d83812528d0e384341b7c065fda98"
        }}>{`538a28a`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.8.0...@kiwicom/orbit-components@2.8.1"
      }}>{`2.8.1`}</a>{` (2022-01-20)`}</h3>
    <p><strong parentName="p">{`Note:`}</strong>{` Version bump only for package @kiwicom/orbit-components`}</p>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.7.0...@kiwicom/orbit-components@2.8.0"
      }}>{`2.8.0`}</a>{` (2022-01-20)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`components:`}</strong>{` fixes after design reviews (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3226"
        }}>{`#3226`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/281bea7b3a093316964385eb6f549ec6283f720f"
        }}>{`281bea7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ErrorFormTooltip:`}</strong>{` close icon on top (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/65b3a0fbee8a3731bef5eae7e827b74284c66d71"
        }}>{`65b3a0f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`FormLabel:`}</strong>{` change color from secondary to info (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a1c3e7d56c7021f94e52361d457013e6cbf69b17"
        }}>{`a1c3e7d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` inlineLabel color from secondary to info (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0b1b03ae54cb4bf08a246acdbbf73c68d666ea64"
        }}>{`0b1b03a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Toast:`}</strong>{` align implementation with type declarations (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5d6fdb950de779863e43c7977f08c4b608b5f933"
        }}>{`5d6fdb9`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Toast:`}</strong>{` fix infinite loop in unit tests (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4fdbe0e214ff6f3a19335dad0b469b3464033729"
        }}>{`4fdbe0e`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com//github.com/timolins/react-hot-toast/issues/107/issues/issuecomment-1017213020"
        }}>{`/github.com/timolins/react-hot-toast/issues/107#issuecomment-1017213020`}</a></li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ErrorForms:`}</strong>{` add helpClosable prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f5a73cccfd0d5dc0a507e93cb21062edf3aff451"
        }}>{`f5a73cc`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tag:`}</strong>{` add new colors and props (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3232"
        }}>{`#3232`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a8961277967360a60045b0fdf8dd1534afb8e799"
        }}>{`a896127`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.6.1...@kiwicom/orbit-components@2.7.0"
      }}>{`2.7.0`}</a>{` (2022-01-14)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Toast:`}</strong>{` fix message type (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3235"
        }}>{`#3235`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/75c2a5d444ce60232efa0a2a8ec4ed2cb85a3da0"
        }}>{`75c2a5d`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Illustration:`}</strong>{` add new illustrations (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3234"
        }}>{`#3234`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f90da394dd2cf384ee65b859333d7fcb69aa2280"
        }}>{`f90da39`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Layout:`}</strong>{` accommodate breadcrumbs on booking (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/cedef08607ba6f3136dec1924ceb06aeb0ef5c98"
        }}>{`cedef08`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.6.0...@kiwicom/orbit-components@2.6.1"
      }}>{`2.6.1`}</a>{` (2022-01-07)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ButtonPrimitive:`}</strong>{` remove line-height (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ea54b4ee5dd61dcb34451146f60b0ad0440c37f3"
        }}>{`ea54b4e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` fix placeholder type (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/42a62445e2e536502d379eb73a55777075c234b6"
        }}>{`42a6244`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.5.1...@kiwicom/orbit-components@2.6.0"
      }}>{`2.6.0`}</a>{` (2021-12-22)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Checkbox:`}</strong>{` fix design discrepancies in border width and radius (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/24b9af2b96ae6f0dd0d10e376fbd9e2adc6bf400"
        }}>{`24b9af2`}</a>{`)`}</li>
      <li parentName="ul">{`fix background color for help tooltip in form components (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8ce16bdc9a00157a6c79a0e8eb4de4119ae2f3ba"
        }}>{`8ce16bd`}</a>{`)`}</li>
      <li parentName="ul">{`fix tooltip’s padding in form components (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c7496c8a0a78c23e148606f26079a49eba643d88"
        }}>{`c7496c8`}</a>{`)`}</li>
      <li parentName="ul">{`increase font weight of labels in form components (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/56fcaeb4a86a6e8162ac89380db4dc4d14a1bddd"
        }}>{`56fcaeb`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Itinerary:`}</strong>{` fix to match design (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3222"
        }}>{`#3222`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/80fa090c0186789a99e73bd45d152bd659927262"
        }}>{`80fa090`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Radio:`}</strong>{` lower focus glow amount (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2a7012f46ce068e7703a2cbe44f861db142f1614"
        }}>{`2a7012f`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Toast:`}</strong>{` introduce toast component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3216"
        }}>{`#3216`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8157669e30b89bf2f207287e410ba952509d6f98"
        }}>{`8157669`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.5.0...@kiwicom/orbit-components@2.5.1"
      }}>{`2.5.1`}</a>{` (2021-12-13)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`remove norefferer from links (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3217"
        }}>{`#3217`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/67353f083f84c96e68887b30008ea72211020938"
        }}>{`67353f0`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Skeleton:`}</strong>{` set fixed height for Text preset (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3214"
        }}>{`#3214`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c7a35c51ed5532955edff2b518f8567b0758ab4a"
        }}>{`c7a35c5`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.4.1...@kiwicom/orbit-components@2.5.0"
      }}>{`2.5.0`}</a>{` (2021-12-07)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`getBreakpointWidth:`}</strong>{` improve typings through overloading (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/069cf8628f3f1e39fcefce72d0f8d702d23320f5"
        }}>{`069cf86`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Heading:`}</strong>{` add missing TypeScript definition for StyledHeading (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/7bdb6e27bbf78916fc5faf64c8ffe17a47c0ba1e"
        }}>{`7bdb6e2`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Heading:`}</strong>{` temporary fix for `}<inlineCode parentName="li">{`viewports`}</inlineCode>{` being `}<inlineCode parentName="li">{`undefined`}</inlineCode>{` (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3212"
        }}>{`#3212`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4f3fb8d2d03d84825898a2a0d28c7eb94033e465"
        }}>{`4f3fb8d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tooltip:`}</strong>{` export interface (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3210"
        }}>{`#3210`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d393f9ac321336bcdd3fbba54f9c92be8ac3b170"
        }}>{`d393f9a`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`add tracking (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3180"
        }}>{`#3180`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/29d01be68cd661254479e4dad1b49d36ba5abd47"
        }}>{`29d01be`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.4.0...@kiwicom/orbit-components@2.4.1"
      }}>{`2.4.1`}</a>{` (2021-12-03)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`useMediaQuery:`}</strong>{` add a fallback for older browsers (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3f51a3c22edcee80d55c077d9c688ee6aaeec47f"
        }}>{`3f51a3c`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.3.0...@kiwicom/orbit-components@2.4.0"
      }}>{`2.4.0`}</a>{` (2021-12-01)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` fix warning caused by the invalid `}<inlineCode parentName="li">{`$width`}</inlineCode>{` attribute (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1afc9d293a4d359d8f6c071b1ccc76c8c989683e"
        }}>{`1afc9d2`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputStepper:`}</strong>{` fix type definitions to export InputStepperStateless (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/36549da8122892eb09876d3b256263157030b565"
        }}>{`36549da`}</a>{`)`}</li>
      <li parentName="ul">{`update `}<inlineCode parentName="li">{`peerDependencies`}</inlineCode>{` to support both `}<inlineCode parentName="li">{`styled-components`}</inlineCode>{` v4 and v5 (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f420ff8b082e918d3c26a6d5c1783022e8704a0f"
        }}>{`f420ff8`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useFocusTrap:`}</strong>{` export from root (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1df0f8f1e034fed20824260dfbb572e7a474a52f"
        }}>{`1df0f8f`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Box:`}</strong>{` support `}<inlineCode parentName="li">{`display="list-item"`}</inlineCode>{` (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b42662a3e66542d4ecc3b831c24966a3f8780b83"
        }}>{`b42662a`}</a>{`)`}</li>
      <li parentName="ul">{`export RTL utilities from root as `}<inlineCode parentName="li">{`rtl`}</inlineCode>{` (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/10f8d1f81a6c88a23ac47ee3740d388d3f23e6ff"
        }}>{`10f8d1f`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.2.0...@kiwicom/orbit-components@2.3.0"
      }}>{`2.3.0`}</a>{` (2021-11-23)`}</h2>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Badge:`}</strong>{` add border and carriers props (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e538b535418d2b76fb63b4279cf87d36a4b2b2b9"
        }}>{`e538b53`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`BadgePrimitive:`}</strong>{` add carriers prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/274795ca8b6440ac14acda58472dabac5a7bca25"
        }}>{`274795c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`CarrierLogo:`}</strong>{` add rounded prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/55aaf50d1f1c82626c83773b935d69765b988ac3"
        }}>{`55aaf50`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Itinerary:`}</strong>{` init (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3a0d40e7bf9f63ed577519dd00535039713ca8c3"
        }}>{`3a0d40e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Text:`}</strong>{` add font-weight medium (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1a361f27edf166e52b59fbd840deee942573235f"
        }}>{`1a361f2`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Text:`}</strong>{` add line-through (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2a74e2dec4d1bd37345178b07b527bd91310f6df"
        }}>{`2a74e2d`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.1.3...@kiwicom/orbit-components@2.2.0"
      }}>{`2.2.0`}</a>{` (2021-11-22)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Box:`}</strong>{` flex-grow and flex-shrink, allow any number (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3190"
        }}>{`#3190`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0243bfa8dac814f5edad292b21e4a19d825ee86e"
        }}>{`0243bfa`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Popover:`}</strong>{` useClickOutside after isLargeMobile (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3189"
        }}>{`#3189`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/02b14876bf69839d248d9ff846e86a3a6a4cf063"
        }}>{`02b1487`}</a>{`)`}</li>
      <li parentName="ul">{`prevent form tooltip from falling off-screen (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8c8a0a8751daa8efb81ca7355a523170a4438c9f"
        }}>{`8c8a0a8`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SmartPassIllustration:`}</strong>{` fix double id (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ada7a0b3c82272abea5665808ad454dad701b095"
        }}>{`ada7a0b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`WizardStepIcon:`}</strong>{` fix transient props (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3184"
        }}>{`#3184`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a560e0f99ef9d084e3602fe428eec005c1849893"
        }}>{`a560e0f`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`icons:`}</strong>{` added new icons (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3199"
        }}>{`#3199`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/28f7575a93fc37d81d3f0d7c258ee107a8f92d16"
        }}>{`28f7575`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.1.2...@kiwicom/orbit-components@2.1.3"
      }}>{`2.1.3`}</a>{` (2021-11-09)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Heading:`}</strong>{` fix error when passing unsupported props (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b52bcdb2984e92fb925e361a957a1d8717b938b8"
        }}>{`b52bcdb`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.1.1...@kiwicom/orbit-components@2.1.2"
      }}>{`2.1.2`}</a>{` (2021-11-09)`}</h3>
    <p><strong parentName="p">{`Note:`}</strong>{` Version bump only for package @kiwicom/orbit-components`}</p>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.1.0...@kiwicom/orbit-components@2.1.1"
      }}>{`2.1.1`}</a>{` (2021-11-05)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`remove uneccessary condition (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3181"
        }}>{`#3181`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e79baabc51531a88796100a14efaf2495730e41b"
        }}>{`e79baab`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.0.1...@kiwicom/orbit-components@2.1.0"
      }}>{`2.1.0`}</a>{` (2021-11-05)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`useMediaQuery:`}</strong>{` optimize, support custom breakpoints, and make it work without context (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8a734fd9d8db7d14725bf1c86b40652f50eeaf33"
        }}>{`8a734fd`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Wizard:`}</strong>{` close after click on WizardStep in compact (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3176"
        }}>{`#3176`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/247e7ae43a8e6983c183bd100806d64c3636b0a7"
        }}>{`247e7ae`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@2.0.0...@kiwicom/orbit-components@2.0.1"
      }}>{`2.0.1`}</a>{` (2021-11-03)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`missing storybook provider (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3173"
        }}>{`#3173`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4967fb7dc2f34a716db7fda30c48952992979562"
        }}>{`4967fb7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useToggle:`}</strong>{` make typings reflect initial param is optional (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/95821c514e8ccf970ec606de219eff301309f914"
        }}>{`95821c5`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.6.1...@kiwicom/orbit-components@2.0.0"
      }}>{`2.0.0`}</a>{` (2021-11-02)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`CountryFlag:`}</strong>{` set “undefined” as default code (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3100"
        }}>{`#3100`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3e841c526326c68140215e9e6afdec7bcb4cc29a"
        }}>{`3e841c5`}</a>{`)`}</li>
      <li parentName="ul">{`refactor and properly initialize media queries (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3138"
        }}>{`#3138`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b566699c00f0ca0e0c15e315f41121302b99cd69"
        }}>{`b566699`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3149"
        }}>{`#3149`}</a></li>
    </ul>
    <h4>{`Code Refactoring`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`TooltipPrimitive:`}</strong>{` use Popper instead of custom logic (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3129"
        }}>{`#3129`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0e2271f7389fd78ec541c60ec540668dff7b7351"
        }}>{`0e2271f`}</a>{`)`}</li>
    </ul>
    <h4>{`BREAKING CHANGES`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`TooltipPrimitive:`}</strong>{` replace props `}<inlineCode parentName="li">{`preferredAlign`}</inlineCode>{` and `}<inlineCode parentName="li">{`preferredPosition`}</inlineCode>{`
with `}<inlineCode parentName="li">{`placement`}</inlineCode>{`, and add new props `}<inlineCode parentName="li">{`noFlip`}</inlineCode>{` and `}<inlineCode parentName="li">{`offset`}</inlineCode>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`CountryFlag:`}</strong>{` The default code for CountryFlag is now `}<inlineCode parentName="li">{`"undefined"`}</inlineCode>{`
rather than `}<inlineCode parentName="li">{`"anywhere"`}</inlineCode>{`, a gray flag with a question mark. This code is
also used if the given code isn’t supported.`}</li>
      <li parentName="ul">{`media queries in `}<inlineCode parentName="li">{`useMediaQuery`}</inlineCode>{` are now being
properly initialized, in `}<inlineCode parentName="li">{`useEffect`}</inlineCode>{` rather than directly in render, which
should prevent some cryptic bugs, but there is a tiny chance that it will
break code for those who have been relying on previous behavior, so it’s
important to be aware of this change.`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.6.0...@kiwicom/orbit-components@1.6.1"
      }}>{`1.6.1`}</a>{` (2021-10-27)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`cloneWithTooltip:`}</strong>{` wrong type declaration (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/52c2418c06fbd4f8ea4aae6765e29ff48c1b2963"
        }}>{`52c2418`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.5.0...@kiwicom/orbit-components@1.6.0"
      }}>{`1.6.0`}</a>{` (2021-10-27)`}</h2>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` add width prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2a2fe0f437a396cfc6c153d19546e3c039dd55d2"
        }}>{`2a2fe0f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputFile:`}</strong>{` add width prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/70d1d397fce90d9160e44a4bc7147170a93414be"
        }}>{`70d1d39`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputStepper:`}</strong>{` add width prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c479f414370adb9f0f728d9d51d997cbdb02ca43"
        }}>{`c479f41`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Select:`}</strong>{` add width prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/865d690bfeaa97844601114bc8db95de2ab9c307"
        }}>{`865d690`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TextLink:`}</strong>{` add active and focus colors (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3df1647bfa94bbd269e57b7b88b7f44c53b25ad0"
        }}>{`3df1647`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.4.0...@kiwicom/orbit-components@1.5.0"
      }}>{`1.5.0`}</a>{` (2021-10-21)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`bring back missing icon Flow declarations (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9c0dcacde636535371d48600cc3cbf32485908e8"
        }}>{`9c0dcac`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ErrorForms:`}</strong>{` fix font-size (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3151"
        }}>{`#3151`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/323c480e9de6a1232c4da9325eb093ec5659fe6c"
        }}>{`323c480`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useLockScrolling:`}</strong>{` support nested scroll locks (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3149"
        }}>{`#3149`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8215c85c6ef237ff65cbcbe14e69d46b8e9af5d5"
        }}>{`8215c85`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`add new icon: deals v2 (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/08edbf921f6f59b38466f34326070c76270d6e28"
        }}>{`08edbf9`}</a>{`)`}</li>
    </ul>
    <h4>{`Reverts`}</h4>
    <ul>
      <li parentName="ul">{`Revert “feat: export Theme type from root (#3125)” (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c0754d985f8a38e7fb434e884b9ebe987a689374"
        }}>{`c0754d9`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3125"
        }}>{`#3125`}</a></li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.3.1...@kiwicom/orbit-components@1.4.0"
      }}>{`1.4.0`}</a>{` (2021-10-20)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ModalHeader:`}</strong>{` remove margins from title (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e9ae04d2d5ca0098a12e38b37078e453992d31f9"
        }}>{`e9ae04d`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`export Theme type from root (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3125"
        }}>{`#3125`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0531faa9a34c628eefb3cb9619770b0d43380bd9"
        }}>{`0531faa`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.3.0...@kiwicom/orbit-components@1.3.1"
      }}>{`1.3.1`}</a>{` (2021-10-18)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Box:`}</strong>{` fix width and height types (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3145"
        }}>{`#3145`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c60308a4f809a002512c27c26d6ce6e6e5e8c712"
        }}>{`c60308a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` improve accessibility and testability (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3143"
        }}>{`#3143`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c4c7bcb198658abe64bacd2b648424a6837d9b7f"
        }}>{`c4c7bcb`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.2.2...@kiwicom/orbit-components@1.3.0"
      }}>{`1.3.0`}</a>{` (2021-10-14)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`useRandomId:`}</strong>{` fix missing UIDReset (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d2e0ec8c2ad158df747173f6dd468a69ca929b38"
        }}>{`d2e0ec8`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Heading:`}</strong>{` add align prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3141"
        }}>{`#3141`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/7dcf2bf5f640b0545ee5000e3f4fef572dce2fa8"
        }}>{`7dcf2bf`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Heading:`}</strong>{` add mediaQuery properties (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3135"
        }}>{`#3135`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1ecaf649eb8fdb4b1c0ec4afb1f366e0fed0765e"
        }}>{`1ecaf64`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.2.1...@kiwicom/orbit-components@1.2.2"
      }}>{`1.2.2`}</a>{` (2021-10-06)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Skeleton:`}</strong>{` fix default height (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/cc02dd3a1bc060a81f38bd5b469f763acbb3ad33"
        }}>{`cc02dd3`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.2.0...@kiwicom/orbit-components@1.2.1"
      }}>{`1.2.1`}</a>{` (2021-10-06)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Card:`}</strong>{` set description Text default as div (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3132"
        }}>{`#3132`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/df60e7303ef63feaa70c80024039ed1802e79e69"
        }}>{`df60e73`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Skeleton:`}</strong>{` default as single rect (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3134"
        }}>{`#3134`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9e0bf270e2cb9562edeed20e90ab4be94d5eb9c1"
        }}>{`9e0bf27`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.1.0...@kiwicom/orbit-components@1.2.0"
      }}>{`1.2.0`}</a>{` (2021-10-01)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`storybook:`}</strong>{` logo url (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3127"
        }}>{`#3127`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/455ded075bf366a2f702fd83037c134492a85bd6"
        }}>{`455ded0`}</a>{`)`}</li>
      <li parentName="ul">{`remove unnecessary declare module statements (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3124"
        }}>{`#3124`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/32805a8ac51eec5a955ba6627b361c506fd35846"
        }}>{`32805a8`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` label before tags (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c25ba7ad0afe213bd78104a20c7fb7dd3fbc72f9"
        }}>{`c25ba7a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Popover:`}</strong>{` transform and transition (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/33f73ad87aa8bb9a1bb8c1716c0095dd96bdccb0"
        }}>{`33f73ad`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Popover:`}</strong>{` ts type definition (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1e61a8125dd87d576a048031a0b7ef39fe803f8c"
        }}>{`1e61a81`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Skeleton:`}</strong>{` allow string values for height and width (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/43f51bb1ab64ae129d5119e379808933a707c02f"
        }}>{`43f51bb`}</a>{`)`}</li>
      <li parentName="ul">{`add component structure component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8cacce077e561b71b2419dea7a24ed6b2d68a587"
        }}>{`8cacce0`}</a>{`)`}</li>
      <li parentName="ul">{`export `}<inlineCode parentName="li">{`useRandomId`}</inlineCode>{` and `}<inlineCode parentName="li">{`useRandomIdSeed`}</inlineCode>{` from root (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/cf4dd1477492a908ab49c018250956f1b1ee57c6"
        }}>{`cf4dd14`}</a>{`)`}</li>
      <li parentName="ul">{`export useTheme hook from root (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a622f6d4bc3f4a5c8b998404a18730a16cac0a2c"
        }}>{`a622f6d`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.0.1...@kiwicom/orbit-components@1.1.0"
      }}>{`1.1.0`}</a>{` (2021-09-22)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Icon:`}</strong>{` explicitly set expected `}<inlineCode parentName="li">{`display`}</inlineCode>{` (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5babd1a6babc426249eec4b2e569cae7d47e53ee"
        }}>{`5babd1a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useLockScrolling:`}</strong>{` ensure that scroll is locked by default (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/bb2da464bb18cef49ff7768c6343cdeb6e66f60e"
        }}>{`bb2da46`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Alert:`}</strong>{` properly style links in Alert (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8d3fff53ee8ade47727e55b54e46b2775d6f2745"
        }}>{`8d3fff5`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@1.0.0...@kiwicom/orbit-components@1.0.1"
      }}>{`1.0.1`}</a>{` (2021-09-13)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` remove aria-labelledby when label is provided (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3103"
        }}>{`#3103`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/724163bd70f52b35bafa381f4c4241b600fba12f"
        }}>{`724163b`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.122.0...@kiwicom/orbit-components@1.0.0"
      }}>{`1.0.0`}</a>{` (2021-09-10)`}</h2>
    <h4>{`Code Refactoring`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Popover:`}</strong>{` replace calculate logic with popper.js (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3046"
        }}>{`#3046`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9b4852d531f1a9e25a7c1efc2c3f0faaa122f84b"
        }}>{`9b4852d`}</a>{`)`}</li>
      <li parentName="ul">{`delete deprecated components (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3084"
        }}>{`#3084`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ee75f0203f5c8afbf389d798db677c4e59d88706"
        }}>{`ee75f02`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`error forms (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2350"
        }}>{`#2350`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/480d5652433758cbe7d024073c2a39a9088207ec"
        }}>{`480d565`}</a>{`)`}</li>
      <li parentName="ul">{`update colour palette (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3095"
        }}>{`#3095`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/acddb14bc0e371568fb53fc74977f0ad9617bd80"
        }}>{`acddb14`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/BAC7D5"
        }}>{`#BAC7D5`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/697D95"
        }}>{`#697D95`}</a>{` `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/4F5E71"
        }}>{`#4F5E71`}</a></li>
    </ul>
    <h4>{`BREAKING CHANGES`}</h4>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Popover:`}</strong></p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`props `}<inlineCode parentName="p">{`preferredPosition`}</inlineCode>{` and `}<inlineCode parentName="p">{`preferredAlign`}</inlineCode>{` are replaced by single prop `}<inlineCode parentName="p">{`placement`}</inlineCode>{`, which same as `}<a parentName="p" {...{
                "href": "https://popper.js.org/docs/v2/constructors/#placement"
              }}>{`popper.js’s placement`}</a>{` can have one of the following values:`}</p>
            <ul parentName="li">
              <li parentName="ul"><inlineCode parentName="li">{`"top-start"`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`"top-end"`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`"bottom-start"`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`"bottom-end"`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`"right-start"`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`"right-end"`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`"left-start"`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`"left-end"`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`"auto"`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`"auto-start"`}</inlineCode></li>
              <li parentName="ul"><inlineCode parentName="li">{`"auto-end"`}</inlineCode></li>
            </ul>
          </li>
          <li parentName="ul">
            <p parentName="li">{`extended by two props:`}</p>
            <ul parentName="li">
              <li parentName="ul"><inlineCode parentName="li">{`noFlip`}</inlineCode>{`:  Turns off automatic flipping of the Popover when there is not enough space`}</li>
              <li parentName="ul"><inlineCode parentName="li">{`allowOverflow`}</inlineCode>{`: Allows the Popover to be cut off instead of moving it while scrolling to keep it visible.`}</li>
            </ul>
          </li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`deletes deprecated components, their usage should be
replaced with better existing or upcoming alternatives.`}</p>
      </li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.121.0...@kiwicom/orbit-components@0.122.0"
      }}>{`0.122.0`}</a>{` (2021-09-09)`}</h2>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Skeleton:`}</strong>{` introduce Skeleton component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3071"
        }}>{`#3071`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6a3cf3d6c45945ff1e3a988a675d919da8fc757e"
        }}>{`6a3cf3d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useLockScrolling:`}</strong>{` allow specifying additional dependencies (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/aac39f0bcd20e92df1f09e3565b0315a024f95e2"
        }}>{`aac39f0`}</a>{`)`}</li>
      <li parentName="ul">{`add `}<inlineCode parentName="li">{`lockScrolling`}</inlineCode>{` theme flag (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/abfe92c2f50299f9d731c66a9ff2b424f53d060d"
        }}>{`abfe92c`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.120.0...@kiwicom/orbit-components@0.121.0"
      }}>{`0.121.0`}</a>{` (2021-09-07)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Badge:`}</strong>{` add border to type white (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3085"
        }}>{`#3085`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/70264ee7160e55293b63babc28ad6067b127bd59"
        }}>{`70264ee`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`CountryFlag:`}</strong>{` disallow `}<inlineCode parentName="li">{`code`}</inlineCode>{` value null (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/481b36cbbbd2814f9fd1d6202402003ac4af2ea6"
        }}>{`481b36c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Drawer:`}</strong>{` fix iOS bug with scrolling content (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/92827abcff5ab7e9938c0e5252cfa3c1e7233ffe"
        }}>{`92827ab`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` fix bug with detached footer (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3093"
        }}>{`#3093`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d552b7826bdfd3687ac06a255ec8a0d7c4a06beb"
        }}>{`d552b78`}</a>{`)`}</li>
      <li parentName="ul">{`add missing TS definitions in ESM build (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/90ec51a5bfdf34b5d844c9e73278ca70a2207217"
        }}>{`90ec51a`}</a>{`)`}</li>
      <li parentName="ul">{`use @kiwicom/orbit-design-tokens’s ESM build (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a85a5210dce433f52b08d63c504316c847ff6178"
        }}>{`a85a521`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`new SSR-friendly useRandomId hook (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3055"
        }}>{`#3055`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1220d8fd285103b191949caaca910a3ab122eeeb"
        }}>{`1220d8f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Illustration:`}</strong>{` add EVisa image (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3091"
        }}>{`#3091`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/23d0ecd3278061e98d49ff34350082ae596a2983"
        }}>{`23d0ecd`}</a>{`)`}</li>
    </ul>
    <h4>{`BREAKING CHANGES`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`CountryFlag:`}</strong>{` Flow and TypeScript type definitions no longer allow
`}<inlineCode parentName="li">{`null`}</inlineCode>{` as value for `}<inlineCode parentName="li">{`CountryFlag`}</inlineCode>{`’s `}<inlineCode parentName="li">{`code`}</inlineCode>{`.`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.119.0...@kiwicom/orbit-components@0.120.0"
      }}>{`0.120.0`}</a>{` (2021-08-19)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`useLockScrolling:`}</strong>{` fix body positioning on iOS (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b780fde9deb8d93073a9a93e445814066aaddc70"
        }}>{`b780fde`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Drawer:`}</strong>{` add lockScrolling (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3072"
        }}>{`#3072`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/bdc4e5873ea3b5183243bae6cc929702cfadcbff"
        }}>{`bdc4e58`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputGroup:`}</strong>{` add `}<inlineCode parentName="li">{`disabled`}</inlineCode>{` prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/61a7f0124eb593b0f3997a3861147b676c576c86"
        }}>{`61a7f01`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.118.1...@kiwicom/orbit-components@0.119.0"
      }}>{`0.119.0`}</a>{` (2021-08-10)`}</h2>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Wizard:`}</strong>{` add lockScrolling prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3070"
        }}>{`#3070`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/38b6456610c37507278f776dcfe20e43ed2329d9"
        }}>{`38b6456`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.118.0...@kiwicom/orbit-components@0.118.1"
      }}>{`0.118.1`}</a>{` (2021-08-05)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` hide closeContainer with mobileHeader set to false (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3065"
        }}>{`#3065`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/78c1a5537a3c028521b72eb91f6a983be9f3201b"
        }}>{`78c1a55`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.117.0...@kiwicom/orbit-components@0.118.0"
      }}>{`0.118.0`}</a>{` (2021-08-05)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ButtonLink:`}</strong>{` use proper design tokens (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3060"
        }}>{`#3060`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2e035be52a6423e36ab4723886245a9d96cc9ad2"
        }}>{`2e035be`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` value color in Safari (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3062"
        }}>{`#3062`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2c1295770d5c952ccd8c0b12520c6a53b21057c3"
        }}>{`2c12957`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` add mobileHeader prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3063"
        }}>{`#3063`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/61065efaaacb623f190766268dde10bcc70a8df4"
        }}>{`61065ef`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.116.0...@kiwicom/orbit-components@0.117.0"
      }}>{`0.117.0`}</a>{` (2021-07-22)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ChoiceGroup:`}</strong>{` use correct box sizing (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/68c2303f0357435d9e5dfdb97e48c19a1c6a54cb"
        }}>{`68c2303`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` add aria-required (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/7d7f5ef1cff154e88185f204990de5230c75742d"
        }}>{`7d7f5ef`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Text:`}</strong>{` allow `}<inlineCode parentName="li">{`justify`}</inlineCode>{` value for `}<inlineCode parentName="li">{`align`}</inlineCode>{` prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3050"
        }}>{`#3050`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c7704b2ee0050d5964572cb4e44b5aa87e060d8b"
        }}>{`c7704b2`}</a>{`)`}</li>
      <li parentName="ul">{`add lockScrolling prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3045"
        }}>{`#3045`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/461139df3ace314c04e11d01a7a5e4495a35e97f"
        }}>{`461139d`}</a>{`)`}</li>
      <li parentName="ul">{`lock scrolling in components with overlay (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3036"
        }}>{`#3036`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b6c87aec9e3005fb76752390c9b4f909bc12f087"
        }}>{`b6c87ae`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Grid:`}</strong>{` add spaceAfter utility prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3043"
        }}>{`#3043`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c65ba9a86bcadb378c424c447c23694e67de6ac4"
        }}>{`c65ba9a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputFile:`}</strong>{` add aria-required (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ef470429c5c1748757d8e85bc7f9eca689162a49"
        }}>{`ef47042`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TextLink:`}</strong>{` add type “white” (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/3000"
        }}>{`#3000`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6a101f1a8dd5daae1e3a55315f6b4eab1617eb06"
        }}>{`6a101f1`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.115.0...@kiwicom/orbit-components@0.116.0"
      }}>{`0.116.0`}</a>{` (2021-06-24)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`CarrierLogo:`}</strong>{` redirects (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2972"
        }}>{`#2972`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/59287d9e198701934c099be45278a5f2cb3c8f6e"
        }}>{`59287d9`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Wizard:`}</strong>{` increase clickable area of steps (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2988"
        }}>{`#2988`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1c55aaac9723e3acfef274e0e935efffb9247a99"
        }}>{`1c55aaa`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ChoiceGroup:`}</strong>{` increase rendering flexibility (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2983"
        }}>{`#2983`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9c2625b5efd4d8de5bee8fc50492cfaee05ddf2e"
        }}>{`9c2625b`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.114.2...@kiwicom/orbit-components@0.115.0"
      }}>{`0.115.0`}</a>{` (2021-05-27)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`HorizontalScroll:`}</strong>{` getSnap (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/98239092d0be2e23ba8ffab2b4bb0b268bdbb52d"
        }}>{`9823909`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`CarrierLogo:`}</strong>{` add kiwicom type fallback (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2959"
        }}>{`#2959`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/041d8d6a6d4d8acf6f7cdd78282f132010949cf1"
        }}>{`041d8d6`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Dialog:`}</strong>{` add insidePortal prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/dbe7785ae8326663500e92c207143f42f1ad92fd"
        }}>{`dbe7785`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`HorizontalScroll:`}</strong>{` add scroll-snap-type (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2964"
        }}>{`#2964`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/837685d29aa200c19f5c3549d12fa756bb7c628b"
        }}>{`837685d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Illustration:`}</strong>{` add GroundTransport404 (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2966"
        }}>{`#2966`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/24771e2adf737137a4fe85bc62effa8f2c32342e"
        }}>{`24771e2`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`MobileDialog:`}</strong>{` add insidePortal prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3b55af6800f04d29318a9a6f25f635c106a684ab"
        }}>{`3b55af6`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` add disableAnimation prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/306455b5c8bf6a303781d0b477c45fd2be76ef12"
        }}>{`306455b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Popover:`}</strong>{` add insidePortal prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/14d126f808720d0e08c08aea3c1de9a0efc94824"
        }}>{`14d126f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TextLink:`}</strong>{` add status types (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2915"
        }}>{`#2915`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/970edc7fe16bb710754db7020c4ef2e2ab63d72c"
        }}>{`970edc7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tooltip:`}</strong>{` add insidePortal prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/fa127e8e55164295bfb22d189153f31170e609ad"
        }}>{`fa127e8`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TooltipPrimitive:`}</strong>{` add insidePortal prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4cb5ddee0a88872f97b4a00fbb2d47bfe0c6f440"
        }}>{`4cb5dde`}</a>{`)`}</li>
      <li parentName="ul">{`introduce BadgeList component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2937"
        }}>{`#2937`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b2b68ecc5b0eac97c0c3c628f7da2cc836bb6050"
        }}>{`b2b68ec`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.114.1...@kiwicom/orbit-components@0.114.2"
      }}>{`0.114.2`}</a>{` (2021-05-17)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ButtonLink:`}</strong>{` pass size prop to icons (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2938"
        }}>{`#2938`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/01847859090fe9b95e41fd6c3944f3aa701180a8"
        }}>{`0184785`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`HorizontalScroll:`}</strong>{` remove automatic height calculation for wrapper (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2936"
        }}>{`#2936`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0880483961e88ccfb1c27c6b9eafe8dd0094b3d5"
        }}>{`0880483`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`MobileDialog:`}</strong>{` change to dialog role (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9895ac79fb4405396dcc3937e97fdf3c4e9072a7"
        }}>{`9895ac7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`popover:`}</strong>{` close on overlay (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e2cef688dd3eecbf15eabafbf70009ac9baee72b"
        }}>{`e2cef68`}</a>{`)`}</li>
      <li parentName="ul">{`pass aria-labelledby for switch labels (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2935"
        }}>{`#2935`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1b10e4c4e708d768149346c5b941202fd72dc431"
        }}>{`1b10e4c`}</a>{`)`}</li>
    </ul>
    <h4>{`Reverts`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` revert CLS changes (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b1d00b4c187d1ed4d25cb3b24a42c84cbe6856d0"
        }}>{`b1d00b4`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.114.0...@kiwicom/orbit-components@0.114.1"
      }}>{`0.114.1`}</a>{` (2021-05-12)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`BaggageStepper:`}</strong>{` forgotten prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2931"
        }}>{`#2931`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6797d73f2395b905cfe8ca9f8d7bc47b775f8171"
        }}>{`6797d73`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` reduce Cumulative Layout Shift (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/21089567a2b25d6e42f432fa44ea40ab21d16785"
        }}>{`2108956`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.113.1...@kiwicom/orbit-components@0.114.0"
      }}>{`0.114.0`}</a>{` (2021-05-05)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Popover:`}</strong>{` fix bug with Tooltip inside Popover on mobile (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/75d8fa41df9afb0d2448ee073a0d2b559d1ae29e"
        }}>{`75d8fa4`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`BaggageStepper:`}</strong>{` init (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2922"
        }}>{`#2922`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0c9c5460f41d34300dfa28b6573db7d855a52f79"
        }}>{`0c9c546`}</a>{`)`}</li>
      <li parentName="ul">{`HorizontalScroll component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2917"
        }}>{`#2917`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d5e59290b6aa6474ef3c5454b427c2a7859f43e1"
        }}>{`d5e5929`}</a>{`)`}</li>
      <li parentName="ul">{`introduce Switch component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/7517675712c36073c909c74ef4b334b92cc97fb1"
        }}>{`7517675`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.113.0...@kiwicom/orbit-components@0.113.1"
      }}>{`0.113.1`}</a>{` (2021-04-28)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Button:`}</strong>{` pass forgotten size prop to utility functions (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8b972812c9fdd8cd985247b139589babf335b59b"
        }}>{`8b97281`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ButtonPrimitive:`}</strong>{` remove redundant size property (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2847"
        }}>{`#2847`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/bec9180e55ac7fe04c08bd51dac37993d432fc3b"
        }}>{`bec9180`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`examples:`}</strong>{` strip flow types from the generated JSONs (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2913"
        }}>{`#2913`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/49f36fd815b75894c223bd79acd00456e159c432"
        }}>{`49f36fd`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SocialButton:`}</strong>{` add forgotten size property to getCommomProps (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a950d6d2b1f60de77fadd9e3cb021a77639306dc"
        }}>{`a950d6d`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.112.0...@kiwicom/orbit-components@0.113.0"
      }}>{`0.113.0`}</a>{` (2021-04-22)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`add TypeScript definition of getTokens (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/267109aa0680f48756bda7c6e87827d500a066ca"
        }}>{`267109a`}</a>{`)`}</li>
      <li parentName="ul">{`add typescript export of defaultTheme (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1047b6117fb705943caeaf64b509a285100ad0b4"
        }}>{`1047b61`}</a>{`)`}</li>
      <li parentName="ul">{`export SeatLegend (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/576027fcca81b72c0b5a968ecef5e5b034a0cc98"
        }}>{`576027f`}</a>{`)`}</li>
      <li parentName="ul">{`update React peer dependency versions (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2898"
        }}>{`#2898`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b841f2d05a96dc023338b527d46910a2d61b2e5f"
        }}>{`b841f2d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Breadcrumbs:`}</strong>{` missing action in default story (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2884"
        }}>{`#2884`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/683bd86a37e15fb89368621ae45604842c0f6a6a"
        }}>{`683bd86`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`docs:`}</strong>{` escape pipe in Alert button props table (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f50485f91a29af1460af8dbd429b078c1e8ba7bb"
        }}>{`f50485f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useBoundingRect:`}</strong>{` fix TypeScript declaration (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2875"
        }}>{`#2875`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/371b30dbdff3fe96d1a2b8c2ead88e1f24288f8a"
        }}>{`371b30d`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`add export of calculateCountOf (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6ac26ff591e332e7ea680d9feb845ad264fb9b0e"
        }}>{`6ac26ff`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`docs:`}</strong>{` update guidance on notification badges (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f5b0da7660d3f7b03294bc882667c10273114ee5"
        }}>{`f5b0da7`}</a>{`)`}</li>
    </ul>
    <h4>{`BREAKING CHANGES`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`useBoundingRect:`}</strong>{` In TypeScript `}<inlineCode parentName="li">{`useBoundingRect`}</inlineCode>{` now requires a type
parameter based on which HTML element it measures:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`function App() {
  const [dimensions, ref] = useBoundingRect<HTMLDivElement>();
  return <div ref={ref} />;
}
`}</code></pre>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.111.1...@kiwicom/orbit-components@0.112.0"
      }}>{`0.112.0`}</a>{` (2021-04-07)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`add default export for Icon stories (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2864"
        }}>{`#2864`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2e9d2c7700c36c78b0c46b36d1cb82104f6659f2"
        }}>{`2e9d2c7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`docs:`}</strong>{` add exports for types (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3acc31e379c8089cdf42383e3459bafff8647190"
        }}>{`3acc31e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`docs:`}</strong>{` change null to 0 (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9eca6cdab0987dd3b0ccef7f648cca39a2f63bd8"
        }}>{`9eca6cd`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`docs:`}</strong>{` remove improper token in enum (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4ab6b2319597574d6fbfa23c95d305754a9163be"
        }}>{`4ab6b23`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TextLink:`}</strong>{` called twice when stopPropagation specified (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2857"
        }}>{`#2857`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4fc78dca23086fd0f9dadd51164774dcd8a83c70"
        }}>{`4fc78dc`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TypeScript:`}</strong>{` fix root mediaQueries export (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/32a70a69de07638cc78fd3961d09bb2184599e8a"
        }}>{`32a70a6`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`eslint-plugin-orbit:`}</strong>{` useRtl rule (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2833"
        }}>{`#2833`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ecb3fd6530cf6c9c0a3115d72bd6fb12f45aef90"
        }}>{`ecb3fd6`}</a>{`)`}</li>
      <li parentName="ul">{`update baggage related icons (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2851"
        }}>{`#2851`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/fb118c91406cabc74b5665cd3c8d75a4e77a1566"
        }}>{`fb118c9`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`playground:`}</strong>{` examples (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2808"
        }}>{`#2808`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6f495cf1e219720033a19d61a304f3c224c5c3ec"
        }}>{`6f495cf`}</a>{`)`}</li>
      <li parentName="ul">{`export useMediaQuery hook from root (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1048599150ed88126f5591fe83a76fb18b72d001"
        }}>{`1048599`}</a>{`)`}</li>
    </ul>
    <h4>{`BREAKING CHANGES`}</h4>
    <ul>
      <li parentName="ul">{`Renamed icons BaggageChecked -> BaggageChecked30; BaggagePersonalItem -> BaggagePersonal; BaggagePersonalItemNone -> BaggagePersonalNone`}</li>
    </ul>
    <p><strong parentName="p">{`Added new icons:`}</strong></p>
    <ul>
      <li parentName="ul">{`BaggageChecked10`}</li>
      <li parentName="ul">{`BaggageChecked20`}</li>
    </ul>
    <p><strong parentName="p">{`Renamed icons:`}</strong></p>
    <ul>
      <li parentName="ul">{`BaggageChecked -> BaggageChecked30`}</li>
      <li parentName="ul">{`BaggagePersonalItem -> BaggagePersonal`}</li>
      <li parentName="ul">{`BaggagePersonalItemNone -> BaggagePersonalNone`}</li>
    </ul>
    <p><strong parentName="p">{`Updated icons:`}</strong></p>
    <ul>
      <li parentName="ul">{`PriorityBorading`}</li>
      <li parentName="ul">{`BaggageCheckedNone`}</li>
      <li parentName="ul">{`BaggageCabin`}</li>
      <li parentName="ul">{`BaggageCabinNone`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.111.0...@kiwicom/orbit-components@0.111.1"
      }}>{`0.111.1`}</a>{` (2021-03-19)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ci:`}</strong>{` deploy storybook only, not build (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2830"
        }}>{`#2830`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f287d1ec507fcb5f93d06f74afe1d2e8d973c958"
        }}>{`f287d1e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`docs:`}</strong>{` misnamed prop for Box (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2825"
        }}>{`#2825`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4e98bd9038f3e30d634a74047308c08467416a31"
        }}>{`4e98bd9`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputFile:`}</strong>{` ref ts type (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2827"
        }}>{`#2827`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1341d57ecd5aa63baafd9f95409941d910153141"
        }}>{`1341d57`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SkipLink:`}</strong>{` missing export (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2794"
        }}>{`#2794`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/eff2c6d0e62fb8f2f151d8935f3e4dbe1879796c"
        }}>{`eff2c6d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useMediaQuery:`}</strong>{` remove listeners on cleanup (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2822"
        }}>{`#2822`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/eb92419e9d0884c4d6013d1598f0de9b85ebbf2f"
        }}>{`eb92419`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Wizard:`}</strong>{` remove incorrect React.ReactChildren (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2829"
        }}>{`#2829`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3f6b80396aac9feb9df621dce2ef2ac70fddf616"
        }}>{`3f6b803`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.110.0...@kiwicom/orbit-components@0.111.0"
      }}>{`0.111.0`}</a>{` (2021-03-08)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`fix script for fetching translations (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2817"
        }}>{`#2817`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/df3633e7e39365f834c85b269a168ac3da7ff7b6"
        }}>{`df3633e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Accordion:`}</strong>{` missing export (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2797"
        }}>{`#2797`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/020f2f3d75b6dc26a5ec9fda717510ef9bd8b1d9"
        }}>{`020f2f3`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ButtonMobileStore:`}</strong>{` missing ts export (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f82f8cd61cc460eae6d3e1572a0ccf71ebe8cdd8"
        }}>{`f82f8cd`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`CalloutBanner:`}</strong>{` illustration type (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2791"
        }}>{`#2791`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3b752e3a8844f80038dee4a655c2928660f3dc86"
        }}>{`3b752e3`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Radio:`}</strong>{` missing tooltip type in d.ts (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4ce4b4eac82db50ab9bbaa04e8b0d5211672ff0b"
        }}>{`4ce4b4e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SocialButton:`}</strong>{` missing export (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2793"
        }}>{`#2793`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/df1f288c62c6eb3d5e28839aa3284680ebc3ad99"
        }}>{`df1f288`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SocialButton:`}</strong>{` missing ts export (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2806aca878afb9ee68345f4ac75462a6376b2ad7"
        }}>{`2806aca`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Timeline:`}</strong>{` type property inside d.ts (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2792"
        }}>{`#2792`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b07f49ca5a45a8c9359a2280d4dae33a36892137"
        }}>{`b07f49c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`validateIncrement:`}</strong>{` fix wrong type (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2796"
        }}>{`#2796`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/bafe8b5f2562d65d2305d1e0d0a5bc23ec1b6744"
        }}>{`bafe8b5`}</a>{`)`}</li>
      <li parentName="ul">{`missing Desktop and Mobile exports (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/033e111c93d1df0add95d1a7e321638a25594171"
        }}>{`033e111`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Tooltip:`}</strong>{` add block prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2813"
        }}>{`#2813`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0f032a8deae42ae333f8a2c0711069393375db52"
        }}>{`0f032a8`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.109.2...@kiwicom/orbit-components@0.110.0"
      }}>{`0.110.0`}</a>{` (2021-03-03)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Box:`}</strong>{` regression test error (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2807"
        }}>{`#2807`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2f2478e585af02afca3aaa951ea0e0c94519199f"
        }}>{`2f2478e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputStepper:`}</strong>{` missing font-family (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2748"
        }}>{`#2748`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8ccebe76084c85be6a994ba2e7b5d4f18ae22eb9"
        }}>{`8ccebe7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Seat:`}</strong>{` add export for SeatLegend and fix TS type of “type” prop  (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2788"
        }}>{`#2788`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9fea5af6201f01b351011937d4416b5dd4d0ba26"
        }}>{`9fea5af`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useIntersect:`}</strong>{` remove unnecessary SSR check (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0b440e631c35a9c1dc5599e098d5e97ee2da5fcc"
        }}>{`0b440e6`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useIntersect:`}</strong>{` simplify `}<inlineCode parentName="li">{`ref`}</inlineCode>{` type (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/573eba08249868c2e8de4a92e04fa9dd63b4fa72"
        }}>{`573eba0`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`utils:`}</strong>{` getDirection (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2782"
        }}>{`#2782`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/01be059cf7b3fbf2445e1741322f331ff6325f54"
        }}>{`01be059`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` autofocus (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2749"
        }}>{`#2749`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/7318569da6665f392ccfa88ea9b5fc3336e38072"
        }}>{`7318569`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`slide:`}</strong>{` added static defaultProps inside class (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e344e612cdedc64e0a8d25ad3f74b91e689b2b34"
        }}>{`e344e61`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`slide:`}</strong>{` added transitionDuration support (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/7e5cf6ab85f1d36ad0738090d0ab06ce2e213255"
        }}>{`7e5cf6a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`slide:`}</strong>{` fixed eslint issues (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d0bd068f227f149a8e70bc11f9fbebda44f93347"
        }}>{`d0bd068`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`slide:`}</strong>{` using defaultProps instead of destruct value (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/140f896b05c772028093f24c511a1477ef5d47c2"
        }}>{`140f896`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Slide:`}</strong>{` added transitionDuration support (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2751"
        }}>{`#2751`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e7b5c728f0ebb3bf4d032c10bccaa187cb76dd54"
        }}>{`e7b5c72`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.109.1...@kiwicom/orbit-components@0.109.2"
      }}>{`0.109.2`}</a>{` (2021-02-16)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Popover:`}</strong>{` readme (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/07aecf20862899762cfd7f37f96fb28d034a98f4"
        }}>{`07aecf2`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Seat:`}</strong>{` active state, spacing (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2734"
        }}>{`#2734`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d59187f902fce1f84c15b381c49b35110b729db7"
        }}>{`d59187f`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.109.0...@kiwicom/orbit-components@0.109.1"
      }}>{`0.109.1`}</a>{` (2021-02-08)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`use postinstall script only in development (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/05cecc434b069d32732c0434186d76877c2f0277"
        }}>{`05cecc4`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.108.2...@kiwicom/orbit-components@0.109.0"
      }}>{`0.109.0`}</a>{` (2021-02-05)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputTags:`}</strong>{` fix cleanup logic (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/7d66ff8458da274a0f48b30f9099f6430e7aa274"
        }}>{`7d66ff8`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`PictureCard:`}</strong>{` label semantic (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2713"
        }}>{`#2713`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0c454e07e5c6bdf96a85b8db005268aa741d00be"
        }}>{`0c454e0`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Seat:`}</strong>{` small selected state (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2715"
        }}>{`#2715`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/84266306b655060a8197c6f23e4289ea68b94d45"
        }}>{`8426630`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useIntersect:`}</strong>{` do nothing in browsers that don’t support IntersectionObserver (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/99d3772da1b386fe620d6c8735760aed754f9779"
        }}>{`99d3772`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`useMediaQuery:`}</strong>{` fix Rules of Hooks violation (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6146505eead568ad12a8bc7e58ed46cea9096157"
        }}>{`6146505`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`eslint-orbit:`}</strong>{` add unique-ids rule (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2671"
        }}>{`#2671`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b6a10570a7fb3f0243fcf96a7f975dce52391fb5"
        }}>{`b6a1057`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Seat:`}</strong>{` new icon sizes, general refactoring (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a86cd07dc6971f694142d836c5ec36cf10419621"
        }}>{`a86cd07`}</a>{`)`}</li>
    </ul>
    <h4>{`BREAKING CHANGES`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Seat:`}</strong>{` separated component for legend, changed icon sizes`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.108.1...@kiwicom/orbit-components@0.108.2"
      }}>{`0.108.2`}</a>{` (2021-01-26)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`unescaped readmes (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2687"
        }}>{`#2687`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d33b47b60d265144745e504780dd77836755ec59"
        }}>{`d33b47b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Seat:`}</strong>{` blueDark change to blueNormal (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2685"
        }}>{`#2685`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/516e8ef92ed3a853d718921e167ca84ccd454218"
        }}>{`516e8ef`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.108.0...@kiwicom/orbit-components@0.108.1"
      }}>{`0.108.1`}</a>{` (2021-01-25)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Seat:`}</strong>{` visual fixes (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2678"
        }}>{`#2678`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a60c333af361add73569c4456589b570c3c8aac3"
        }}>{`a60c333`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.107.0...@kiwicom/orbit-components@0.108.0"
      }}>{`0.108.0`}</a>{` (2021-01-22)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Accordion:`}</strong>{` missing onExpand ts (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4a644293f97a415a01e6a05cb55bcc6412d61b26"
        }}>{`4a64429`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Card:`}</strong>{` missing titleAs in d.ts (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2666"
        }}>{`#2666`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0f60daa418b7efbd69a8e4c9a94f8a30528f920b"
        }}>{`0f60daa`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`IllustrationPrimitive:`}</strong>{` allow empty alt (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1c9e3d783ea0957fc447be3342c5b5bcdb196e4d"
        }}>{`1c9e3d7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tag:`}</strong>{` focus only if onClick/onRemove provided (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/41a163a764b679e3813cdc1daf217a71f7f278a0"
        }}>{`41a163a`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Tag:`}</strong>{` add forwardRef (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4445cbb37944172d0b859a605a2bfb84de9f2dfa"
        }}>{`4445cbb`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tag:`}</strong>{` Icon prop removed, changed colors (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4b918c0bdf2b3077fb63306daf6ffb52cd8165b8"
        }}>{`4b918c0`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.106.0...@kiwicom/orbit-components@0.107.0"
      }}>{`0.107.0`}</a>{` (2021-01-13)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`seat:`}</strong>{` randomize id to prevent namespace errors (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/114e38f1f4e0e4301d192cf03d81aa127a37f987"
        }}>{`114e38f`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`deprecate old Seat component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/99001b0c9d7adc5869a21e7aa7978f48c56a7dc5"
        }}>{`99001b0`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`box:`}</strong>{` add minWidth (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e325c1984e64c66f32cb43289ed138fbaf40abb6"
        }}>{`e325c19`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`CountryFlag:`}</strong>{` add “undefined” flag (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2654"
        }}>{`#2654`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/fa5fe665d0250c99161f8c7832fde87d17f50336"
        }}>{`fa5fe66`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.105.0...@kiwicom/orbit-components@0.106.0"
      }}>{`0.106.0`}</a>{` (2021-01-07)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Box:`}</strong>{` fix null values (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/eacb1815758f79cf417c88d141f7cef71d152eaf"
        }}>{`eacb181`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Box:`}</strong>{` set padding/marging to 0 if none (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f5eee37c890134e042a125e30ef980b094d12429"
        }}>{`f5eee37`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`CardSection:`}</strong>{` title and icon alignment (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2618"
        }}>{`#2618`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3d2b7952047ae7d29d889d1483e54e4218994708"
        }}>{`3d2b795`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` ensure header overlay if title exists (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2634"
        }}>{`#2634`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/bf2a8e09dc8524d9c1199799eff38def6228b66d"
        }}>{`bf2a8e0`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Wizard:`}</strong>{` translate close button (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2630"
        }}>{`#2630`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/25d351b752ba6b76ca69c1170816bb4badcb0343"
        }}>{`25d351b`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`popover:`}</strong>{` offset (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2633"
        }}>{`#2633`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ea71b6428784be6c779b130c14749c1b14d70266"
        }}>{`ea71b64`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`seat:`}</strong>{` new version of seat component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2623"
        }}>{`#2623`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e09134523d8960fdfb150c8ed4861607c662d3b0"
        }}>{`e091345`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TableCell:`}</strong>{` add normal white-space (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2637"
        }}>{`#2637`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4bc34edc1cb5247ec06208a9f587b9a3db4b51ed"
        }}>{`4bc34ed`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.104.0...@kiwicom/orbit-components@0.105.0"
      }}>{`0.105.0`}</a>{` (2020-12-18)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Box:`}</strong>{` missing box-sizing (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2616"
        }}>{`#2616`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/51246ca926cfab134098bca8d216b9fb7bbfe662"
        }}>{`51246ca`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`CardSection:`}</strong>{` missing hover (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2615"
        }}>{`#2615`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d62d192f673c165e953339fe250667a904019342"
        }}>{`d62d192`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`CardSection:`}</strong>{` add onClick (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2614"
        }}>{`#2614`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/074ded07055f2c606aa7b474de514e27fe63b7cd"
        }}>{`074ded0`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.103.0...@kiwicom/orbit-components@0.104.0"
      }}>{`0.104.0`}</a>{` (2020-12-17)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Box:`}</strong>{` apply `}<inlineCode parentName="li">{`largeMobile`}</inlineCode>{` properties (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2612"
        }}>{`#2612`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e55c88ea6d60d81cd492dce3a3a5e9a4e74edb33"
        }}>{`e55c88e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Button:`}</strong>{` change color of outline on focus (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2611"
        }}>{`#2611`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e2b038451485858a2166a68e0cd44fc37dc989dc"
        }}>{`e2b0384`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputFile:`}</strong>{` a11y fixes (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/be39d803f579d0f3dc607cfc51aeec1a39a232f3"
        }}>{`be39d80`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tag:`}</strong>{` add missing aria-label (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/26789fb6c3378dff9cec49028f552a3aef16c232"
        }}>{`26789fb`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tile:`}</strong>{` missing a11y attributes (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3959338be443a409c53c707def932f6dbfa96e93"
        }}>{`3959338`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`add widthModalExtraLarge token (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2592"
        }}>{`#2592`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5213c498a7fade644d8d85ba821adfb5b25c162e"
        }}>{`5213c49`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Sticky:`}</strong>{` add data-test (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e01e6d22cc86eba6e6bfe908daff52b775b78518"
        }}>{`e01e6d2`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.102.0...@kiwicom/orbit-components@0.103.0"
      }}>{`0.103.0`}</a>{` (2020-12-10)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`SkipLink:`}</strong>{` sr-only styles, label as aria-label (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/eb0d625bda51daefa34b74a863f32860306dbad5"
        }}>{`eb0d625`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SmartPassIllustration:`}</strong>{` linergradients missing ids restored (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/93fd176e46a2862ac9a2d34df3ff2b17fc26f7ba"
        }}>{`93fd176`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Wizard:`}</strong>{` translate progress label on mobile (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2576"
        }}>{`#2576`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/cf6fc542a1ec0cad60dda133eb29d8f056afc812"
        }}>{`cf6fc54`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` extended size (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2575"
        }}>{`#2575`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9de69e9fe36b4c9591d8bb9919fd3e03d71a72fb"
        }}>{`9de69e9`}</a>{`)`}</li>
    </ul>
    <h4>{`BREAKING CHANGES`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` size prop is changed, added new value
CODEMODE: `}<inlineCode parentName="li">{`jscodeshift -t https://raw.githubusercontent.com/kiwicom/orbit/master/packages/orbit-components/transforms/Modal-size.js <pathToYourCode> --parser=flow|t`}</inlineCode></li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.101.0...@kiwicom/orbit-components@0.102.0"
      }}>{`0.102.0`}</a>{` (2020-12-01)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Accordion:`}</strong>{` allow any children type in Flow (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2552"
        }}>{`#2552`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1f7e37d7991e750451329801c5171686e71a9aaf"
        }}>{`1f7e37d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Popover:`}</strong>{` popover bottom position issue (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2540"
        }}>{`#2540`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4b251ad3f5e388aced3bb29a51ff128f015906a7"
        }}>{`4b251ad`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SmartPassIllustration:`}</strong>{` change smartPass api, to reduce bundle size (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2529"
        }}>{`#2529`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/761d3f39bd0fb6f5b8ea428410958eb491377ff9"
        }}>{`761d3f3`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Textarea:`}</strong>{` add required prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2532"
        }}>{`#2532`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/904a78f04b316955f57b84dbb4e240f6067f4dc4"
        }}>{`904a78f`}</a>{`)`}</li>
    </ul>
    <h4>{`BREAKING CHANGES`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`SmartPassIllustration:`}</strong>{` API of SmartPassIllustation has changed`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.100.1...@kiwicom/orbit-components@0.101.0"
      }}>{`0.101.0`}</a>{` (2020-11-26)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` expose modalBody and modalContent (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/500cf6b9556190fb30be0a3736591fc4238d89b1"
        }}>{`500cf6b`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` add scrollingElementRef prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0cf4f7e6e646974a3b8dbaf50507de1a312b43e1"
        }}>{`0cf4f7e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SmartPassIllustration:`}</strong>{` added v5 image (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2519"
        }}>{`#2519`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f7186513257324c9fa79bc118c90e17184beea00"
        }}>{`f718651`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.100.0...@kiwicom/orbit-components@0.100.1"
      }}>{`0.100.1`}</a>{` (2020-11-24)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`expose getScrollPosition in Modal (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2528"
        }}>{`#2528`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ecd5b9f0d556b80519bae735110bb9acb3de3946"
        }}>{`ecd5b9f`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.99.0...@kiwicom/orbit-components@0.100.0"
      }}>{`0.100.0`}</a>{` (2020-11-23)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`RTL:`}</strong>{` fix Flow types of utilities (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2520"
        }}>{`#2520`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d696b4cc59dfeaf35f49d3099c845bb2ab992487"
        }}>{`d696b4c`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2331"
        }}>{`#2331`}</a></li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputStepper:`}</strong>{` added readonly prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2495"
        }}>{`#2495`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/74fee3f208dcd6f89e66f92f66710a0fa68982f3"
        }}>{`74fee3f`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.98.0...@kiwicom/orbit-components@0.99.0"
      }}>{`0.99.0`}</a>{` (2020-11-19)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Popover:`}</strong>{` a11y issues (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/45dbbdf094f688252a2a01a325ac823514609781"
        }}>{`45dbbdf`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Timeline:`}</strong>{` make subLabel optional (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2505"
        }}>{`#2505`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8cb77f011a2365ff178be7422827efcb19d0aef2"
        }}>{`8cb77f0`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tooltip:`}</strong>{` only call `}<inlineCode parentName="li">{`preventDefault`}</inlineCode>{` on mobile (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2502"
        }}>{`#2502`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f73940b5803311fb4b57418a6e384ea2ae7b5a0e"
        }}>{`f73940b`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2230"
        }}>{`#2230`}</a></li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`SmartPassIllustration component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2504"
        }}>{`#2504`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4c8ba9c1e3c98a734689ed04801d7d982136ba71"
        }}>{`4c8ba9c`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.96.3...@kiwicom/orbit-components@0.98.0"
      }}>{`0.98.0`}</a>{` (2020-11-10)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Layout:`}</strong>{` use the correct tags for columns (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2487"
        }}>{`#2487`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f092fa9e26aeacc74d5bc0b56a488f5ab8355ef3"
        }}>{`f092fa9`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ListChoice:`}</strong>{` disabled items should not get focus (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2474"
        }}>{`#2474`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/08eb9c4a364385b0baaef39f8e4c635989f5cb7e"
        }}>{`08eb9c4`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` lost focus on user interaction (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2484"
        }}>{`#2484`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ef3e4f9bf1a6b61812e42c5c7b16d9df3556678f"
        }}>{`ef3e4f9`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Select:`}</strong>{` added readOnly prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2493"
        }}>{`#2493`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2b06b276d6165e6f1d0baaf93da1e991cedafc4a"
        }}>{`2b06b27`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Textarea:`}</strong>{` added readOnly prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2494"
        }}>{`#2494`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d33c396714ba8e9e4931fa31796571c7c69e30c4"
        }}>{`d33c396`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.96.3...@kiwicom/orbit-components@0.97.0"
      }}>{`0.97.0`}</a>{` (2020-11-10)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Accordion:`}</strong>{` Accordion sticky footer story (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2483"
        }}>{`#2483`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/09127f819da1e04f016d3590a78c8c079611bcac"
        }}>{`09127f8`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Inline:`}</strong>{` add around and between (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2476"
        }}>{`#2476`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/554e536cf64098812f62572b180a43ee6bec660c"
        }}>{`554e536`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Button:`}</strong>{` div behave like button, a11y (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2426"
        }}>{`#2426`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/93cc6018f7287f8e192241acd0812c3a9106abef"
        }}>{`93cc601`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.96.2...@kiwicom/orbit-components@0.96.3"
      }}>{`0.96.3`}</a>{` (2020-11-09)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` expose setScrollPosition via forwardRef (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2472"
        }}>{`#2472`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3f30a63cfcbf9791fdf6bedc10f7e1909edca5fc"
        }}>{`3f30a63`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` fix TypeScript definition for ref (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2479"
        }}>{`#2479`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/86c5c7e55cd44d98501e26784c29f2a67f452ded"
        }}>{`86c5c7e`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.96.1...@kiwicom/orbit-components@0.96.2"
      }}>{`0.96.2`}</a>{` (2020-11-06)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Inline:`}</strong>{` add inner wrapper for negative margin (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2469"
        }}>{`#2469`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/efd7ab2d2b1866d2727b3fc290b87754c76307b1"
        }}>{`efd7ab2`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.96.0...@kiwicom/orbit-components@0.96.1"
      }}>{`0.96.1`}</a>{` (2020-11-05)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Stack:`}</strong>{` change spacing value TS types (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2468"
        }}>{`#2468`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f572b4ce634f9e9b3d4ce29003ceb88f28d4e34e"
        }}>{`f572b4c`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.95.0...@kiwicom/orbit-components@0.96.0"
      }}>{`0.96.0`}</a>{` (2020-11-04)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputFile:`}</strong>{` forward onFocus event handler (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2461"
        }}>{`#2461`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/92ad4da10e4c90b81917083af762a9ae7bf6048f"
        }}>{`92ad4da`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SkipNavigation:`}</strong>{` fix typos in stories (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2414"
        }}>{`#2414`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b380a1cd70649bbea781fb026c659b1ea5902bf6"
        }}>{`b380a1c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Stack:`}</strong>{` add forgotten interface export (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2456"
        }}>{`#2456`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a85d20aee69b29ac8a5305a77ad9078623569e48"
        }}>{`a85d20a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tooltip:`}</strong>{` do not propagate the onClick event on mobile when stopPropagate is set to true (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2438"
        }}>{`#2438`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/00467c5d3f77e49f2fbccf848c8ae0328c38f8ad"
        }}>{`00467c5`}</a>{`)`}</li>
      <li parentName="ul">{`remove //flow from `}{`*`}{`.d.ts (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5a57884281dc952ad959e53608b3a9dee8239e85"
        }}>{`5a57884`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`CountryFlag`}</strong>{` stop exporting `}<inlineCode parentName="li">{`getCountryProps`}</inlineCode>{` (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/pull/2436"
        }}>{`#2436`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e001aabea64b132977ba534ee54eb059794a68a4"
        }}>{`e001aabe`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ButtonPrimitive`}</strong>{` correctly forward `}<inlineCode parentName="li">{`ref`}</inlineCode>{` (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/pull/2418"
        }}>{`#2418`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/cf4c4f33fc41fa7af80d2861014ea653dc44cd89"
        }}>{`cf4c4f33`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`introduce Box component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2242"
        }}>{`#2242`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/226bec7f95143474df073ff0f6efe89d5a3f7a81"
        }}>{`226bec7`}</a>{`)`}</li>
      <li parentName="ul">{`introduce Inline component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2255"
        }}>{`#2255`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ef005000b522d28b842e3c7651cac31540d1debe"
        }}>{`ef00500`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`AlertButton:`}</strong>{` set small as default size for alert button (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2391"
        }}>{`#2391`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1a6d0bea34771c0b08ac196946b606ad23dc662b"
        }}>{`1a6d0be`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Stack:`}</strong>{` change spacing value names (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2457"
        }}>{`#2457`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6a9363bab5c39632e1c245832014a3375b64d3fb"
        }}>{`6a9363b`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2451"
        }}>{`#2451`}</a></li>
    </ul>
    <h4>{`BREAKING CHANGES`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Stack:`}</strong>{` Renaming spacing values of `}<inlineCode parentName="li">{`Stack`}</inlineCode>{` component and `}<inlineCode parentName="li">{`LinkList`}</inlineCode>{` component – that was using Stack internally.`}</li>
    </ul>
    <p>{`Also dropped support of different spacings between mobile and desktop version. It no longer make sense from design point of view.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`AlertButton:`}</strong>{` Removed size property from AlertButton since only the small size should be used and from now, it’s the default value. No actions should be necessary. If you used different than small size, just remove the usage of the property.
Co-authored-by: Luděk Vepřek `}<a parentName="li" {...{
          "href": "mailto:weprous@gmail.com"
        }}>{`weprous@gmail.com`}</a></li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.94.0...@kiwicom/orbit-components@0.95.0"
      }}>{`0.95.0`}</a>{` (2020-10-23)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Timeline:`}</strong>{` IE fixes (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2370"
        }}>{`#2370`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e2d1953af1a339f42ead0ed4dbe716fc52d52d62"
        }}>{`e2d1953`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tooltip:`}</strong>{` missing MobileDialog data-test (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2382"
        }}>{`#2382`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/00bf878821ca59de024eb6ec0886f8e7b7b03000"
        }}>{`00bf878`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Eslint:`}</strong>{` add rules for enforcing readOnly types on TS/Flow (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2331"
        }}>{`#2331`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/26d13b52ce62da4f41f48237a469c84c7e24f11b"
        }}>{`26d13b5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ListChoice:`}</strong>{` add disabled boolean property (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2355"
        }}>{`#2355`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4f135e5b7bd07202dd507acad5375619fee1aa0a"
        }}>{`4f135e5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Loki:`}</strong>{` skip code blocks (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2389"
        }}>{`#2389`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9d4c7d1af63735d652440cf0c9003e834e4b4fc5"
        }}>{`9d4c7d1`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2346"
        }}>{`#2346`}</a></li>
      <li parentName="ul"><strong parentName="li">{`orbit:`}</strong>{` transitions defaults to on (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2372"
        }}>{`#2372`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d2338e385f04d262de4fd82fe736eb5a12a6ffbe"
        }}>{`d2338e3`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TextLink:`}</strong>{` add standAlone, noUnderline & iconRight, rename icon to iconLeft (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/pull/2373"
        }}>{`#2373`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/76959c865fbb942bfafd9b67b4e2cc45897ab67a"
        }}>{`76959c86`}</a>{`)`}
        <ul parentName="li">
          <li parentName="ul">{`for renaming `}<inlineCode parentName="li">{`icon`}</inlineCode>{` to `}<inlineCode parentName="li">{`iconRight`}</inlineCode>{` there’s a codemod available, see `}<a parentName="li" {...{
              "href": "https://github.com/kiwicom/orbit/pull/2380#issuecomment-713441576"
            }}>{`https://github.com/kiwicom/orbit/pull/2380#issuecomment-713441576`}</a></li>
        </ul>
      </li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.93.0...@kiwicom/orbit-components@0.94.0"
      }}>{`0.94.0`}</a>{` (2020-10-19)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`TextLink:`}</strong>{` ariaCurrent should in optional in TS definition (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2365"
        }}>{`#2365`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/09857f7d9b64fc791b2371a2a43b3a709484be2f"
        }}>{`09857f7`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Grid:`}</strong>{` add width property (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2356"
        }}>{`#2356`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ee8943e4d59d73fa9d95573fffe8df4ece04ede7"
        }}>{`ee8943e`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/@kiwicom/orbit-components@0.92.0...@kiwicom/orbit-components@0.93.0"
      }}>{`0.93.0`}</a>{` (2020-10-16)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`add padding to InputField text suffix (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2338"
        }}>{`#2338`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6b7702161fd7b052c3a2a4dfe636cd6eb759a271"
        }}>{`6b77021`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Breadcrumbs:`}</strong>{` add check for absence of props on mobile (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2259"
        }}>{`#2259`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/7bd4ab3cc74b7c42a6d3817d6712865709a7e1bd"
        }}>{`7bd4ab3`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Breadcrumbs:`}</strong>{` spacing from 8 to 4 (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2311"
        }}>{`#2311`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b51bd21926a22393ab270c0de5b593299760a94a"
        }}>{`b51bd21`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ButtonPrimitive:`}</strong>{` align text to right in RTL (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f26c45e86f1f19c3c035f9eccae7644d23c27536"
        }}>{`f26c45e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Docs:`}</strong>{` primitives default (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/dd91c4f254bb8c3240972d0708324d5ff2d624d8"
        }}>{`dd91c4f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Hide:`}</strong>{` span to div (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2277"
        }}>{`#2277`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3bcc1bbc82a0b0fe75610cc110c7c07983d6b664"
        }}>{`3bcc1bb`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ModalSection:`}</strong>{` margin-top (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2340"
        }}>{`#2340`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4a7def0168cacbe1b943a55f09ec5bccc8644ff3"
        }}>{`4a7def0`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Slide:`}</strong>{` initialize max-height to work SSR (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2339"
        }}>{`#2339`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ff7dce8185d198ae847a3330287ab75dc5837f2b"
        }}>{`ff7dce8`}</a>{`)`}</li>
      <li parentName="ul">{`fix InputGroup/LayoutColumn TS typing (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2326"
        }}>{`#2326`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/de5296870ec89ba1c3c17fa7fb4a936171ebced8"
        }}>{`de52968`}</a>{`)`}</li>
      <li parentName="ul">{`move collapsable aria labels to the focusable button (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2319"
        }}>{`#2319`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ad8708bfd32af8966ec505032b7e703944b75b1a"
        }}>{`ad8708b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tile:`}</strong>{` fix newWindow icon on external (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2264"
        }}>{`#2264`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4ea9639fbd1ea693a9f315a2c0ee00d2f872ced5"
        }}>{`4ea9639`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Accordion:`}</strong>{` added Accordion component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2280"
        }}>{`#2280`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9d244990ecc3e1c39ff60fc6caa5c5e4c3edda5a"
        }}>{`9d24499`}</a>{`)`}</li>
      <li parentName="ul">{`add Wizard component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/99229b1586acbf9ed093fa277a63c7333f73ecf5"
        }}>{`99229b1`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ButtonPrimitive:`}</strong>{` add support for aria-current (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d26067b648e23402fbfefdd9110b3cde0671ed0d"
        }}>{`d26067b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Illustration:`}</strong>{` added image to images.kiwi (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2312"
        }}>{`#2312`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/66527820fd4529b3f58a2be20387a175befafddd"
        }}>{`6652782`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` adding a autofocus attribute (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2236"
        }}>{`#2236`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3ebec2ec954aaf7941282e71b921f4fd954562c0"
        }}>{`3ebec2e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` add prop to remove the close button (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d96f46d9b4fced03cd8677bb8eb5a4a72c235ea9"
        }}>{`d96f46d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TextLink:`}</strong>{` add support for aria-current (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9e0b3e2b6fb4129931da3a8ece0796e8a07d0b12"
        }}>{`9e0b3e2`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Timeline:`}</strong>{` init component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2287"
        }}>{`#2287`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9447edf6f2cdcfb10a72da133b9aeb2b18a3a928"
        }}>{`9447edf`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tooltip:`}</strong>{` refactoring Tooltip into 2 separate components (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2230"
        }}>{`#2230`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/df3b3be122c92b4d0c29c6d72171cda866bdb471"
        }}>{`df3b3be`}</a>{`)`}</li>
      <li parentName="ul">{`add an agnostic entry point for icons (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2237"
        }}>{`#2237`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/597d1ecefd543a79936af9a658be6b401c934a9a"
        }}>{`597d1ec`}</a>{`)`}</li>
    </ul>
    <h2>{`0.92.0 (2020-09-09)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Layout:`}</strong>{` width of Card on mobile (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2181"
        }}>{`#2181`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8daca18b382e04873d781f457c1294aae353134e"
        }}>{`8daca18`}</a>{`)`}</li>
      <li parentName="ul">{`updating TypeScript definitions to match Flow (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2202"
        }}>{`#2202`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d476c2f95bb260b72611bfb19a55c294fc72478d"
        }}>{`d476c2f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Docs:`}</strong>{` internal github links (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2182"
        }}>{`#2182`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/da1226162b0cd3fee7c31f6ab8da97cf4b642feb"
        }}>{`da12261`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Table:`}</strong>{` updating default align and removing unnecessary vertical-align options (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2204"
        }}>{`#2204`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0bfe9ae0da094586a2818fb733ee5219802099df"
        }}>{`0bfe9ae`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tooltip:`}</strong>{` enable event bubbling for disabled children (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2201"
        }}>{`#2201`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5f26d88d65ca1fc20b1cd2badf3bfd9fc03c2ede"
        }}>{`5f26d88`}</a>{`)`}</li>
      <li parentName="ul">{`update docs and icons link for monorepo (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2200"
        }}>{`#2200`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/27f49746c12a1adeb2721f9c31b323b074e98aea"
        }}>{`27f4974`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Hooks:`}</strong>{` useIntersect (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2091"
        }}>{`#2091`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/dd65d65d55e6b90e47765160fd610fdd8441e3f0"
        }}>{`dd65d65`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Icons:`}</strong>{` add double chevron icons (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2190"
        }}>{`#2190`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f0ce1f96c918d3859590752f305a9e59497b1094"
        }}>{`f0ce1f9`}</a>{`)`}</li>
    </ul>
    <h4>{`Reverts`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Layout:`}</strong>{` width of Card on mobile (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2228"
        }}>{`#2228`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/09a5429138d2f922b54d45e573f07f85181bd141"
        }}>{`09a5429`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.90.0...0.90.1"
      }}>{`0.90.1`}</a>{` (2020-08-06)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Pricingtable:`}</strong>{` rendering of wrapped mobile child (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2094"
        }}>{`#2094`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5713e76aadb4f8fd59af61edb2f84099d0843b75"
        }}>{`5713e76`}</a>{`)`}</li>
      <li parentName="ul">{`popover memory leak (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2095"
        }}>{`#2095`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9a9a89023130e3d111618dbb03f9f5697adb0b7f"
        }}>{`9a9a890`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`types:`}</strong>{` adjust Breadcrumbs, Tile, Button type declarations and exports (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2096"
        }}>{`#2096`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b6cdc68ffac754dc1c4ca162aaec2cf40dacde11"
        }}>{`b6cdc68`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`types:`}</strong>{` adjust typescript types for heading and textarea (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2093"
        }}>{`#2093`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0fcd753f22e5067cdc42004f6c4feef94a559d97"
        }}>{`0fcd753`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.89.0...0.90.0"
      }}>{`0.90.0`}</a>{` (2020-08-05)`}</h2>
    <ul>
      <li parentName="ul">{`fix!(Popover): actions on mobile are no longer hidden (#2040) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1a7100832a1dda020f09ec4ef6dfd1a18d7032bd"
        }}>{`1a71008`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2040"
        }}>{`#2040`}</a></li>
      <li parentName="ul">{`feat!(PricingTable): adding option to display radio buttons on desktop (#2076) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8d1fee4041293e12f4609908d38d62bc0e85473d"
        }}>{`8d1fee4`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2076"
        }}>{`#2076`}</a></li>
    </ul>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`IllustrationPrimitive:`}</strong>{` defaulting flex shrink to false (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2036"
        }}>{`#2036`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0a867f16794535d4d9caa041ca7b1a5ac3730ac0"
        }}>{`0a867f1`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputStepper, Stepper:`}</strong>{` callbacks triggered when disabled (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2050"
        }}>{`#2050`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/81ed35be583686c64d7fd7ae7a8531a58833a853"
        }}>{`81ed35b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Layout:`}</strong>{` edge to edge behavior of deprecated Card (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2049"
        }}>{`#2049`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/637f677147c2a1423eb5201bf39ebefed7cfe953"
        }}>{`637f677`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ListChoice:`}</strong>{` set role to checkbox when selectable is true (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2062"
        }}>{`#2062`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/70d1625627953520f32d945996096ef93008876b"
        }}>{`70d1625`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Rtl:`}</strong>{` flow definition of destructured assigment (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2077"
        }}>{`#2077`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6dd89e23e824decd81b8cb442d7bf2f37aa752d0"
        }}>{`6dd89e2`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Typescript:`}</strong>{` updating definitions (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2083"
        }}>{`#2083`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b1fc89fcbb5f2cfe4aefc24436a7d93a95f8887b"
        }}>{`b1fc89f`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Breadcrumbs:`}</strong>{` add backHref prop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2048"
        }}>{`#2048`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/58e049340436a75d8f058503b99eb46e40c9a950"
        }}>{`58e0493`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ButtonMobileStore:`}</strong>{` adding light variants (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2059"
        }}>{`#2059`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d534554a5ad335bcce9448c854256b2027f5cb65"
        }}>{`d534554`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` adding extraSmall size option (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2078"
        }}>{`#2078`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/17fa9ae6bf716a5021989a628cfcbfbb07e59930"
        }}>{`17fa9ae`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SocialButton:`}</strong>{` adding twitter type (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2057"
        }}>{`#2057`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/cb1c97dca7b58b56fe9503e791d62ad00cfb9fbc"
        }}>{`cb1c97d`}</a>{`)`}</li>
    </ul>
    <h4>{`BREAKING CHANGES`}</h4>
    <ul>
      <li parentName="ul">{`adding a padding-top to Actions causing it to potentially collide with some wrappers with padding which might be in place`}</li>
      <li parentName="ul">{`activeElement no longer passes active to children`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.88.0...0.89.0"
      }}>{`0.89.0`}</a>{` (2020-07-17)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Breadcrumbs:`}</strong>{` unification of style from figma (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2032"
        }}>{`#2032`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8c8868db821e0f9a401d0b4d4a4d9fea964461f8"
        }}>{`8c8868d`}</a>{`)`}</li>
      <li parentName="ul">{`extend type of tabIndex to allow numbers (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2029"
        }}>{`#2029`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/96c1a7b6f906af5d6e231eb02fdda1b25a500979"
        }}>{`96c1a7b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputStepper:`}</strong>{` onChange is triggered when disabled (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2024"
        }}>{`#2024`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/387806c63e5da13657b995389c42f81557492a0a"
        }}>{`387806c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Layout:`}</strong>{` inner usage of Card – edge to edge behavior (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2025"
        }}>{`#2025`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3d475f3d986c12286ce264f7d2f7ee7121858d4a"
        }}>{`3d475f3`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Buttons:`}</strong>{` adding rel attribute (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/2028"
        }}>{`#2028`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/df8507e35abab58f71890ca4c77103cd70c03d59"
        }}>{`df8507e`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.87.2...0.88.0"
      }}>{`0.88.0`}</a>{` (2020-06-30)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Breadcrumbs:`}</strong>{` unnecessary optional event (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1959"
        }}>{`#1959`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d4034a78b4f9df76d1fa2b2fafd3f6cc9e672d6f"
        }}>{`d4034a7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Select:`}</strong>{` customValueText interpolation (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1957"
        }}>{`#1957`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f528d0c171dc8aaf1f1e6a66ebefdb4996e096d2"
        }}>{`f528d0c`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SocialButton:`}</strong>{` inner content align (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1983"
        }}>{`#1983`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2b57e3a205bfa70d5946a236c45d60da93745991"
        }}>{`2b57e3a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`UseMediaQuery:`}</strong>{` remove unnecessary debounce (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1982"
        }}>{`#1982`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/bc73651e624574f36c5582b9dc8b42024aa1e1ed"
        }}>{`bc73651`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.87.1...0.87.2"
      }}>{`0.87.2`}</a>{` (2020-06-16)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ButtonPrimitive:`}</strong>{` fallback to text-align (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1946"
        }}>{`#1946`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/bd7f59f870aae6a005f170e4332a98e2272d46dd"
        }}>{`bd7f59f`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Portal:`}</strong>{` state init on SSR (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1954"
        }}>{`#1954`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1f43f7abd1493cf7592e3d0c9a69a04570dec1a4"
        }}>{`1f43f7a`}</a>{`)`}</li>
      <li parentName="ul">{`tests folder names (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1940"
        }}>{`#1940`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/9bd091c5b5c93f930fd1879e52e45d5eed361287"
        }}>{`9bd091c`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.87.0...0.87.1"
      }}>{`0.87.1`}</a>{` (2020-06-12)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Breadcrumbs:`}</strong>{` add mobile back button onClick (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1944"
        }}>{`#1944`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2bb09e0921ba2d73daf4eb113b24242ee0434dde"
        }}>{`2bb09e0`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.86.0...0.87.0"
      }}>{`0.87.0`}</a>{` (2020-06-11)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ButtonGroup:`}</strong>{` mobile border radius (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1934"
        }}>{`#1934`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/08316d18ceaea05e627649e351d4112d358383c5"
        }}>{`08316d1`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Portal:`}</strong>{` usage with Tooltip (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1935"
        }}>{`#1935`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/67e88d67a1fefd3605646c7a1b164d0024864d3c"
        }}>{`67e88d6`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tag:`}</strong>{` onRemove now shows close button (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1931"
        }}>{`#1931`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0156b7f9ec22ccdd41c7fe19fd313418aa2a36ee"
        }}>{`0156b7f`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ButtonLink:`}</strong>{` inline type and compact property, remove transparent (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1912"
        }}>{`#1912`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8e2f1286d8ef2f90330e6960af399a583d993bc1"
        }}>{`8e2f128`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ButtonPrimitive:`}</strong>{` adding responsive visual style behaviour (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1911"
        }}>{`#1911`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/06a86224c00a2c2594e2ffd433b10878e25b7c9a"
        }}>{`06a8622`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Dialog:`}</strong>{` change spacing between title and description (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1922"
        }}>{`#1922`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/7718db7552ae2c6ca84f63f4bb8bfd9c9c18773c"
        }}>{`7718db7`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`FormElements:`}</strong>{` adding mobile border radius (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1915"
        }}>{`#1915`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3a3c22782edcadb6447b38ac7d6dfe037ad83292"
        }}>{`3a3c227`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`General:`}</strong>{` adding display name to react contexts (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1936"
        }}>{`#1936`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c1a0da4fe7e985732ea17c7bdec6d7666afc1603"
        }}>{`c1a0da4`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`MediaQuery:`}</strong>{` adding prefersReducedMotion (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1921"
        }}>{`#1921`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/dd807cbfb6dd47a3fce4a6c630a07dbe892be149"
        }}>{`dd807cb`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Portal:`}</strong>{` refactor to hooks (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1923"
        }}>{`#1923`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/04ad88683e7e7c3128e073bd3b3b6806cb04e1e5"
        }}>{`04ad886`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Stack:`}</strong>{` add baseline to align options (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1930"
        }}>{`#1930`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/eecc296ca8b425f17527fc9a11da04332db7cbe6"
        }}>{`eecc296`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TextLink:`}</strong>{` change focus state to non underlined text (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1914"
        }}>{`#1914`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e2bb67dda64477347168a5629b921811ab62ad71"
        }}>{`e2bb67d`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.85.2...0.86.0"
      }}>{`0.86.0`}</a>{` (2020-06-01)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputStepper:`}</strong>{` removing native arrows on Firefox (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1889"
        }}>{`#1889`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2c61e3b786e2b6a1ec8d363789d19ab634e96e36"
        }}>{`2c61e3b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`MediaQuery:`}</strong>{` spread type (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1899"
        }}>{`#1899`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c78ab3f54701443c436b88e297e512672969a8f4"
        }}>{`c78ab3f`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` adding onSelect, onMouseUp, onMouseDown (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1883"
        }}>{`#1883`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8ce9435eb07b8a898fd56f957701f78194029a8f"
        }}>{`8ce9435`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`PictureCard:`}</strong>{` Add src attribute (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1544"
        }}>{`#1544`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5a17c0b6c476ad5cbae1e31bee4037b7fc8efd86"
        }}>{`5a17c0b`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Table:`}</strong>{` adding striped on Table. Scope and as on TableCell (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1881"
        }}>{`#1881`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5d49cfd6786a919f10db34b33f112d7d67482259"
        }}>{`5d49cfd`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TableCell:`}</strong>{` adding white-space and vertical align options (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1910"
        }}>{`#1910`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/538044350cbb099b4b297964f3577f18a805dc8c"
        }}>{`5380443`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.85.1...0.85.2"
      }}>{`0.85.2`}</a>{` (2020-05-21)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`defaultTheme global declaration and references of themeType (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1876"
        }}>{`#1876`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6e1e60e7cca922139221d3cda81930710cc397da"
        }}>{`6e1e60e`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.85.0...0.85.1"
      }}>{`0.85.1`}</a>{` (2020-05-20)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`InputStepper:`}</strong>{` improve TypeScript definition (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1865"
        }}>{`#1865`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/86915f30f7959479997f93d038a03c49eb565879"
        }}>{`86915f3`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Typescript:`}</strong>{` defaultTheme, missing instance (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1873"
        }}>{`#1873`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/d7e62cf8b7b4ab4ffaab0350ad718d993aa9166b"
        }}>{`d7e62cf`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.84.2...0.85.0"
      }}>{`0.85.0`}</a>{` (2020-05-15)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`AlertButton:`}</strong>{` missing export in entry file (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1848"
        }}>{`#1848`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1e4336a7155e031bf7c8bca1f47ecaba6f26b7b3"
        }}>{`1e4336a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Breadcrumbs:`}</strong>{` render in RTL (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1836"
        }}>{`#1836`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a427b7003d15e33563c0fc25eef92c2d1163b0c2"
        }}>{`a427b70`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ButtonPrimitive:`}</strong>{` interactive states when disabled (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1846"
        }}>{`#1846`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5de0ad36ba3549af40da1a0bb01a36ddb55d84b0"
        }}>{`5de0ad3`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`FormElements:`}</strong>{` adding aria polite to errors (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1840"
        }}>{`#1840`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/14196cc2e7fb06cd402333cc3c8ea1564641d425"
        }}>{`14196cc`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ModalHeader:`}</strong>{` illustration type to Node (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1829"
        }}>{`#1829`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8775caa9200a8f6e29f858055c15d9070f284ea3"
        }}>{`8775caa`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Table:`}</strong>{` min-height on table (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1823"
        }}>{`#1823`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/c116c279e22707f8c24e39d325a6748cc2c78ab2"
        }}>{`c116c27`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Icons:`}</strong>{` adding colorPicker icon (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1841"
        }}>{`#1841`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/b79fbe61582468c9fca7784b3cef296131442cd3"
        }}>{`b79fbe6`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` illustration size (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1830"
        }}>{`#1830`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3bf4fac8bb95b2a60918106bf5c001bd8c193aae"
        }}>{`3bf4fac`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Pagination:`}</strong>{` not hiding buttons at the end/start of the list (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1843"
        }}>{`#1843`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/67e867ac86604073907328c8881f234c1b512bee"
        }}>{`67e867a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`ServiceLogo:`}</strong>{` new Maestro and MasterCard short variants (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1847"
        }}>{`#1847`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a4fae803ac093b37694b9941bf81fe7cbde6d797"
        }}>{`a4fae80`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`TypeScript:`}</strong>{` adding type definitions (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1504"
        }}>{`#1504`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a2ea0ecc3080afae5b2e38f611e98137c5bd91dd"
        }}>{`a2ea0ec`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.84.1...0.84.2"
      }}>{`0.84.2`}</a>{` (2020-04-29)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ButtonPrimitive:`}</strong>{` disabled render to DOM element (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1813"
        }}>{`#1813`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/014781087bc609c757f5acd1729601c9b612ce2e"
        }}>{`0147810`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.84.0...0.84.1"
      }}>{`0.84.1`}</a>{` (2020-04-28)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Button:`}</strong>{` missing white type in flow definition (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1806"
        }}>{`#1806`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/153b158d0cd86dc639a5fcace3d0db288e0563e1"
        }}>{`153b158`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.83.0...0.84.0"
      }}>{`0.84.0`}</a>{` (2020-04-27)`}</h2>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul">{`adding extraSmall size to illustrations (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1800"
        }}>{`#1800`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/7987772d37d324ef86978b0c8e3e6a476a676a23"
        }}>{`7987772`}</a>{`)`}</li>
      <li parentName="ul">{`introduce useBoundingRect hook (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1771"
        }}>{`#1771`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ba9597be44383cddc22e50dbfb9562b5d5014dc5"
        }}>{`ba9597b`}</a>{`)`}</li>
      <li parentName="ul">{`moving separated type of List to PricingTable only (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1801"
        }}>{`#1801`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/93629b5d8a267aabd428b2cfe38d0138ab3ba9ed"
        }}>{`93629b5`}</a>{`)`}</li>
      <li parentName="ul">{`rename element property to as (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1273"
        }}>{`#1273`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/91ff946a69af5756749c4b431b2312357104e225"
        }}>{`91ff946`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Buttons:`}</strong>{` introduce SocialButton (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1803"
        }}>{`#1803`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ac41d6094b69e684b2857e2d43712be6b60e1848"
        }}>{`ac41d60`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Drawer:`}</strong>{` title alignment (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1790"
        }}>{`#1790`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5fb4708fc64157dcac2774ec9672833b7ee5356f"
        }}>{`5fb4708`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`SkipLink:`}</strong>{` Rename description to buttonLabel on SkipLink (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1686"
        }}>{`#1686`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/99e4017a5b1a1dc264274df2a58b2051f829cc7e"
        }}>{`99e4017`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Table:`}</strong>{` adding new type and footer (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1788"
        }}>{`#1788`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/075d9f33b820a4f0299a71c304843a5f294c5018"
        }}>{`075d9f3`}</a>{`)`}</li>
      <li parentName="ul">{`introduce global onlyIE media query selector (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1772"
        }}>{`#1772`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/1b48f6b6ec7f71aa35211ea0fc1e04752a6ede91"
        }}>{`1b48f6b`}</a>{`)`}</li>
    </ul>
    <ul>
      <li parentName="ul">{`feat(Buttons)!: Introduce ButtonPrimitive, implementing planned breaking changes (#1522) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ca4a6411ad2e8a2b28f5efe1e7dd534459a7abbf"
        }}>{`ca4a641`}</a>{`), closes `}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1522"
        }}>{`#1522`}</a></li>
    </ul>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`types of asComponent (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1787"
        }}>{`#1787`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a80b468ee90ae30b1e43d3c7d939e2f8c4e683f4"
        }}>{`a80b468`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Card:`}</strong>{` font-size of title in section header (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1776"
        }}>{`#1776`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a2e3a52aaa2031b0be198853859114e4dd3c3a47"
        }}>{`a2e3a52`}</a>{`)`}</li>
    </ul>
    <h4>{`BREAKING CHANGES`}</h4>
    <ul>
      <li parentName="ul">{`Shifting small size to extraSmall`}</li>
      <li parentName="ul">{`removes a separated type from List`}</li>
      <li parentName="ul"><strong parentName="li">{`SkipLink:`}</strong>{` renaming description prop`}</li>
      <li parentName="ul"><strong parentName="li">{`Buttons:`}</strong>{` Removing info, success, warning, facebook, google types from Button.
Removing bordered property from Button.`}</li>
      <li parentName="ul">{`removing unsafe className (deprecated, not public API)
removing icon property (deprecated)
changing type of width to string (planned)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.82.1...0.83.0"
      }}>{`0.83.0`}</a>{` (2020-04-03)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Compass:`}</strong>{` broken svg definition for icon font (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1759"
        }}>{`#1759`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f8e7b721f16fb8984414117e63f121196fc300ea"
        }}>{`f8e7b72`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tooltip:`}</strong>{` calculation upon change in the wrapped element (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1761"
        }}>{`#1761`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e7b5474047f8d3a7fa09e70a0de879cd8c7f685f"
        }}>{`e7b5474`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ChoiceGroup:`}</strong>{` updating the filter color from product color (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1757"
        }}>{`#1757`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e1ad6f20e0b822fcba88568b2709594083d03be7"
        }}>{`e1ad6f2`}</a>{`)`}</li>
      <li parentName="ul">{`adding new ButtonMobileStore component (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1756"
        }}>{`#1756`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/223c846d556050d19b46134260610f508d36d844"
        }}>{`223c846`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Alert:`}</strong>{` changing the alignment of description (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1758"
        }}>{`#1758`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/fff86ca43ee497897bbcd12346f06a3c5a8d2f2f"
        }}>{`fff86ca`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.82.0...0.82.1"
      }}>{`0.82.1`}</a>{` (2020-04-01)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Tooltip:`}</strong>{` with clickable element should close on mobile (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1752"
        }}>{`#1752`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/3af61f8caddf2d2a3762dfb24f846736f6214a90"
        }}>{`3af61f8`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.81.0...0.82.0"
      }}>{`0.82.0`}</a>{` (2020-03-31)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Hide:`}</strong>{` omit rendering of on property (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1740"
        }}>{`#1740`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e34331729802b5fc380d5970cecea1e44e5d7fbf"
        }}>{`e343317`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`InputField:`}</strong>{` Tag alignment (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1744"
        }}>{`#1744`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/133f718cbd945f10cfbd5245b678409693af8b73"
        }}>{`133f718`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`modal:`}</strong>{` border radius of close container on desktop (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1726"
        }}>{`#1726`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/fc3b4aa2ba48eb595f76a92e67a292aef2e27239"
        }}>{`fc3b4aa`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal:`}</strong>{` click ability under CloseContainer (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1739"
        }}>{`#1739`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/2368987f0d1c58307b303bb1d3eaac714263ca22"
        }}>{`2368987`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`radar:`}</strong>{` SVG definition (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1728"
        }}>{`#1728`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/843d1bda68e368a69e220b79d956f9a3ce9a27fb"
        }}>{`843d1bd`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tooltip:`}</strong>{` should close when clicked on clickable element (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1742"
        }}>{`#1742`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a4e226eac9981c039d195884a7e3dd2d54dc16e1"
        }}>{`a4e226e`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Checkbox,Radio:`}</strong>{` Updating visual style (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1737"
        }}>{`#1737`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8ff47d7a265c3586366f3adde3a597e5111cf573"
        }}>{`8ff47d7`}</a>{`)`}</li>
      <li parentName="ul">{`Adding commitlint and husky (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1730"
        }}>{`#1730`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e96446e8347d8f4406fc9d2bf80ba1cfeb9604f6"
        }}>{`e96446e`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`card:`}</strong>{` new titleAs property (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1729"
        }}>{`#1729`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/fa50675db518d932f40e2012bd69d4446b9f9df4"
        }}>{`fa50675`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`icons:`}</strong>{` New Radar icon (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1725"
        }}>{`#1725`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/93e14fcf39e72706afeddc8cdc171ff9f18e96d6"
        }}>{`93e14fc`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tile:`}</strong>{` change padding to large for desktop breakpoint (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1732"
        }}>{`#1732`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ce9b531713349b890d03362ae685e7099d8b4606"
        }}>{`ce9b531`}</a>{`)`}</li>
    </ul>
    <h4>{`Reverts`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`FormElements:`}</strong>{` native design sync (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1743"
        }}>{`#1743`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f351e4618e3495cb6a42a4b66e23d4157e3f403d"
        }}>{`f351e46`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.80.0...0.81.0"
      }}>{`0.81.0`}</a>{` (2020-03-24)`}</h2>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Select:`}</strong>{` Add optional key to Option (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1708"
        }}>{`#1708`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/f824d4a762edc70598746a3533fa470fc53e90b6"
        }}>{`f824d4a`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tile:`}</strong>{` introduce noHeaderIcon property (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1710"
        }}>{`#1710`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/0183561c5f14e595f3df76c620c8966999467cbe"
        }}>{`0183561`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.79.0...0.80.0"
      }}>{`0.80.0`}</a>{` (2020-03-20)`}</h2>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Tile:`}</strong>{` Adding htmlTitle attribute (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1691"
        }}>{`#1691`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a1628ba78cad62734ca4d87414a3e18989020e9c"
        }}>{`a1628ba`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.78.0...0.79.0"
      }}>{`0.79.0`}</a>{` (2020-03-17)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Breadcrumbs:`}</strong>{` add correct html5 structured microdata for breadcrumbs (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1666"
        }}>{`#1666`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/692b3f57a50745ce12161a8088338ad84af5eda2"
        }}>{`692b3f5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`tooltip:`}</strong>{` usage of TextLink in content (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1680"
        }}>{`#1680`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/139a787d4c3d7eebf9ff991282d23cbb75428bec"
        }}>{`139a787`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`servicelogo:`}</strong>{` Add Booking and RentalCars logos (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1682"
        }}>{`#1682`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/fb94862eaf3e61e305710044981bd40a818806d9"
        }}>{`fb94862`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Tag:`}</strong>{` Update visual style (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1573"
        }}>{`#1573`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e3634060a9848625f9503a6c9d9e38bcbd8f1538"
        }}>{`e363406`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`theme:`}</strong>{` Added transitions property (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1668"
        }}>{`#1668`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/e8f86e64e6280e0ceb50b9eda2083df66089e8e7"
        }}>{`e8f86e6`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.77.1...0.78.0"
      }}>{`0.78.0`}</a>{` (2020-03-12)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`button:`}</strong>{` circled not being perfect circle with small children (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1654"
        }}>{`#1654`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/280905dd1a1a03e94d745d8695e2bf8723c59d68"
        }}>{`280905d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`button:`}</strong>{` Fix flow type of the button export (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1663"
        }}>{`#1663`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4c07ca0adb959425bd09041b244cfb6c57c9b70b"
        }}>{`4c07ca0`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`pictureCard:`}</strong>{` Enabling heiight to be smaller than 200 (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1660"
        }}>{`#1660`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/633fbe543352785ff8405087033af06642097fe5"
        }}>{`633fbe5`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`popover:`}</strong>{` Border radius on desktop and close button padding (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1658"
        }}>{`#1658`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/50b2a24f8bd8fc42c8c21200ffae22f11d295385"
        }}>{`50b2a24`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`popover:`}</strong>{` Opening with onKeyDown event (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1657"
        }}>{`#1657`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/ea27780a6592a5e0a4ab4b8f3e847cfb65bb89e1"
        }}>{`ea27780`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`popover:`}</strong>{` RTL calculation (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1653"
        }}>{`#1653`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/8572fea4939385d08a0b211877c0d1b3790ec57c"
        }}>{`8572fea`}</a>{`)`}</li>
    </ul>
    <h4>{`Features`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`dictionary:`}</strong>{` add index.js export of all languages (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1650"
        }}>{`#1650`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/83f5a9d6e37950b1bce3a57ac12ef74b444f7f2c"
        }}>{`83f5a9d`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`illustrations:`}</strong>{` Add optional alt property (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1656"
        }}>{`#1656`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4a60dfda0dae50dd6551410c94edb90664cabf00"
        }}>{`4a60dfd`}</a>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`modal:`}</strong>{` Change title size to title2 on mobile (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/5ab25f2352e2db73c778953d7bd86bdc5f55662e"
        }}>{`5ab25f2`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.77.0...0.77.1"
      }}>{`0.77.1`}</a>{` (2020-03-09)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`popover:`}</strong>{` position calculations (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1647"
        }}>{`#1647`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/6c0fcad28d0d5abeb49a6a1098fbee17093ad3b2"
        }}>{`6c0fcad`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.76.0...0.77.0"
      }}>{`0.77.0`}</a>{` (2020-03-06)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.75.0...0.76.0"
      }}>{`0.76.0`}</a>{` (2020-02-25)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.74.0...0.75.0"
      }}>{`0.75.0`}</a>{` (2020-02-19)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.73.1...0.74.0"
      }}>{`0.74.0`}</a>{` (2020-02-18)`}</h2>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`components:`}</strong>{` PictureCard href (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1536"
        }}>{`#1536`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/4866b9e545ae32b341c822ab520677b6cffe2b1e"
        }}>{`4866b9e`}</a>{`)`}</li>
    </ul>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.73.0...0.73.1"
      }}>{`0.73.1`}</a>{` (2020-02-12)`}</h3>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.72.0...0.73.0"
      }}>{`0.73.0`}</a>{` (2020-02-07)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.71.0...0.72.0"
      }}>{`0.72.0`}</a>{` (2020-01-27)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.70.0...0.71.0"
      }}>{`0.71.0`}</a>{` (2020-01-15)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.69.0...0.70.0"
      }}>{`0.70.0`}</a>{` (2019-12-18)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.68.0...0.69.0"
      }}>{`0.69.0`}</a>{` (2019-12-06)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.67.1...0.68.0"
      }}>{`0.68.0`}</a>{` (2019-11-27)`}</h2>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.67.0...0.67.1"
      }}>{`0.67.1`}</a>{` (2019-11-13)`}</h3>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.66.0...0.67.0"
      }}>{`0.67.0`}</a>{` (2019-11-11)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.65.0...0.66.0"
      }}>{`0.66.0`}</a>{` (2019-10-31)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.64.2...0.65.0"
      }}>{`0.65.0`}</a>{` (2019-10-22)`}</h2>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.64.1...0.64.2"
      }}>{`0.64.2`}</a>{` (2019-10-16)`}</h3>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.64.0...0.64.1"
      }}>{`0.64.1`}</a>{` (2019-10-14)`}</h3>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.63.0...0.64.0"
      }}>{`0.64.0`}</a>{` (2019-10-11)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.62.0...0.63.0"
      }}>{`0.63.0`}</a>{` (2019-10-04)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.61.3...0.62.0"
      }}>{`0.62.0`}</a>{` (2019-10-02)`}</h2>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.61.2...0.61.3"
      }}>{`0.61.3`}</a>{` (2019-10-01)`}</h3>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.61.1...0.61.2"
      }}>{`0.61.2`}</a>{` (2019-09-25)`}</h3>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.61.0...0.61.1"
      }}>{`0.61.1`}</a>{` (2019-09-25)`}</h3>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.60.0...0.61.0"
      }}>{`0.61.0`}</a>{` (2019-09-21)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.59.0...0.60.0"
      }}>{`0.60.0`}</a>{` (2019-09-16)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.58.0...0.59.0"
      }}>{`0.59.0`}</a>{` (2019-09-12)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.57.0...0.58.0"
      }}>{`0.58.0`}</a>{` (2019-09-04)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.56.0...0.57.0"
      }}>{`0.57.0`}</a>{` (2019-09-03)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.55.0...0.56.0"
      }}>{`0.56.0`}</a>{` (2019-08-27)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.54.0...0.55.0"
      }}>{`0.55.0`}</a>{` (2019-08-21)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.53.0...0.54.0"
      }}>{`0.54.0`}</a>{` (2019-08-15)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.52.0...0.53.0"
      }}>{`0.53.0`}</a>{` (2019-08-08)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.51.0...0.52.0"
      }}>{`0.52.0`}</a>{` (2019-07-31)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.50.0...0.51.0"
      }}>{`0.51.0`}</a>{` (2019-07-24)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.49.1...0.50.0"
      }}>{`0.50.0`}</a>{` (2019-07-17)`}</h2>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.49.0...0.49.1"
      }}>{`0.49.1`}</a>{` (2019-07-02)`}</h3>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.48.0...0.49.0"
      }}>{`0.49.0`}</a>{` (2019-07-01)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.47.0...0.48.0"
      }}>{`0.48.0`}</a>{` (2019-06-18)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.46.0...0.47.0"
      }}>{`0.47.0`}</a>{` (2019-06-10)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.45.0...0.46.0"
      }}>{`0.46.0`}</a>{` (2019-06-05)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.44.0...0.45.0"
      }}>{`0.45.0`}</a>{` (2019-05-31)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.43.0...0.44.0"
      }}>{`0.44.0`}</a>{` (2019-05-29)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.42.0...0.43.0"
      }}>{`0.43.0`}</a>{` (2019-05-27)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.41.0...0.42.0"
      }}>{`0.42.0`}</a>{` (2019-05-20)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.40.1...0.41.0"
      }}>{`0.41.0`}</a>{` (2019-05-15)`}</h2>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.40.0...0.40.1"
      }}>{`0.40.1`}</a>{` (2019-05-02)`}</h3>
    <h4>{`Bug Fixes`}</h4>
    <ul>
      <li parentName="ul">{`build script to include data dir in compilation (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/issues/1025"
        }}>{`#1025`}</a>{`) (`}<a parentName="li" {...{
          "href": "https://github.com/kiwicom/orbit/commit/a71ab3d48b164a384b051e21b198aa5746bd6314"
        }}>{`a71ab3d`}</a>{`)`}</li>
    </ul>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.39.1...0.40.0"
      }}>{`0.40.0`}</a>{` (2019-04-30)`}</h2>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.39.0...0.39.1"
      }}>{`0.39.1`}</a>{` (2019-04-23)`}</h3>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.38.1...0.39.0"
      }}>{`0.39.0`}</a>{` (2019-04-17)`}</h2>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.38.0...0.38.1"
      }}>{`0.38.1`}</a>{` (2019-04-05)`}</h3>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.37.0...0.38.0"
      }}>{`0.38.0`}</a>{` (2019-04-04)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.36.0...0.37.0"
      }}>{`0.37.0`}</a>{` (2019-03-27)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.35.0...0.36.0"
      }}>{`0.36.0`}</a>{` (2019-03-22)`}</h2>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.34.1...0.35.0"
      }}>{`0.35.0`}</a>{` (2019-03-15)`}</h2>
    <h3><a parentName="h3" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.34.0...0.34.1"
      }}>{`0.34.1`}</a>{` (2019-03-11)`}</h3>
    <h2><a parentName="h2" {...{
        "href": "https://github.com/kiwicom/orbit/compare/0.33.0...0.34.0"
      }}>{`0.34.0`}</a>{` (2019-03-08)`}</h2>
    <h2>{`0.0.0-rc5 (2018-02-28)`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      